import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import {
  validaSoloNumero,
  validaEmail,
} from "../../util/varios";
import moment from "moment";
import axios from "axios";
import { Loader, Dimmer } from "semantic-ui-react";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoOrganizacion from "../../catalogosAthos/catalogoOrganizacion";
import { CambiarClave } from "./modalCambiarClave";
import { Mensaje, MensajeSiNo } from "../mensajes";

const ModalActualizarUsuario = (props) => {
  let idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
  let idusuario = JSON.parse(sessionStorage.getItem("idusuario"));

  const cmbRif = useRef();
  const txtRif = useRef();
  const txtRazon = useRef();
  const txtIdVendedor = useRef();
  const cmbCaja = useRef();

  const chkPerCon = useRef();
  const chkPerIn = useRef();
  const chkPerMod = useRef();
  const chkPerEli = useRef();
  const chkPerTodo = useRef();

  const chkUsuCon = useRef();
  const chkUsuIn = useRef();
  const chkUsuMod = useRef();
  const chkUsuEli = useRef();
  const chkUsuTodo = useRef();

  const chkUsuappCon = useRef();
  const chkUsuappIn = useRef();
  const chkUsuappMod = useRef();
  const chkUsuappEli = useRef();
  const chkUsuappTodo = useRef();

  const chkMoneCon = useRef();
  const chkMoneIn = useRef();
  const chkMoneMod = useRef();
  const chkMoneEli = useRef();
  const chkMoneTodo = useRef();

  const chkPorCon = useRef();
  const chkPorIn = useRef();
  const chkPorMod = useRef();
  const chkPorEli = useRef();
  const chkPorTodo = useRef();

  const chkUWebCon = useRef();
  const chkUWebIn = useRef();
  const chkUWebMod = useRef();
  const chkUWebEli = useRef();
  const chkUWebTodo = useRef();

  const chkUAppCon = useRef();
  const chkUAppIn = useRef();
  const chkUAppMod = useRef();
  const chkUAppEli = useRef();
  const chkUAppTodo = useRef();

  const chkOrgCon = useRef();
  const chkOrgIn = useRef();
  const chkOrgMod = useRef();
  const chkOrgEli = useRef();
  const chkOrgTodo = useRef();

  const chkralmacen = useRef();
  const chkubialmacen = useRef();
  const chkudmedida = useRef();
  const chkmarca = useRef();
  const chkmodelo = useRef();
  const chktpproduct = useRef();
  const chkproducto = useRef();
  const chkopinventario = useRef();
  const chkactxlsx = useRef();
  const chkgvacios = useRef();
  const chkiconfigura = useRef();
  const chkireports = useRef();
  const chkitodos = useRef();

  const chkvtodos = useRef();
  const chkclientes = useRef();
  const chkvendedores = useRef();
  const chkpedidos = useRef();
  const chknentrega = useRef();
  const chkndebito = useRef();
  const chkfactura = useRef();
  const chkfacturaxnotas = useRef();
  const chkpresupuesto = useRef();
  const chkvconfi = useRef();
  const chkvreports = useRef();

  const chkcptodos = useRef();
  const chkproveedores = useRef();
  const chkordencompra = useRef();
  const chkfactucompra = useRef();
  const chkcpconfig = useRef();
  const chkcpreports = useRef();

  const chkcnttodos = useRef();
  const chkcatctcontable = useRef();
  const chkasientcntable = useRef();
  const chkvincuenta = useRef();
  const chkmovibancot = useRef();
  const chkcntconfig = useRef();
  const chkcntreports = useRef();

  const chkftodos = useRef();
  const chkbancos = useRef();
  const chkbeneficiarios = useRef();
  const chkctasbancarias = useRef();
  const chkmovibancarios = useRef();
  const chkmovitransito = useRef();
  const chkconciliacionbanco = useRef();
  const chkctasxcobrar = useRef();
  const chkReverPagoAnti = useRef();
  const chkctasxpagar = useRef();
  const chktiporetenciones = useRef();
  const chkfconfig = useRef();
  const chkfreports = useRef();

  const chkvaciostodos = useRef();
  const chkopvacios = useRef();
  const chkcontrolvacios = useRef();
  const chkclassvacios = useRef();
  const chkvaciosconfig = useRef();
  const chkvaciosreports = useRef();

  const chkpostventtodos = useRef();
  const chkpostventventa = useRef();
  const chksupervisor = useRef();
  const cmbTipoPrecioGlobal = useRef();

  const chkinicio = useRef();

  const chkservtodos = useRef();
  const chkordenservi = useRef();
  const chkmovilesservi = useRef();
  const chkgservicios = useRef();
  const chkservconfig = useRef();
  const chkservreports = useRef();
  const chkservnotaent = useRef();

  const moduinventariosi = useRef();
  const moduinventariono = useRef();
  const moduventassi = useRef();
  const moduventasno = useRef();
  const moducomprassi = useRef();
  const moducomprasno = useRef();
  const moducontabsi = useRef();
  const moducontabno = useRef();
  const modufinanzassi = useRef();
  const modufinanzasno = useRef();
  const moduconfigsi = useRef();
  const moduconfigno = useRef();
  const moduvaciossi = useRef();
  const moduvaciosno = useRef();
  const moduserviciossi = useRef();
  const moduserviciosno = useRef();
  const modupostventasi = useRef();
  const modupostventano = useRef();

  const [aplica, setAplica] = useState();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnEnviar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [modu1, setModu1] = useState(0);
  const [modu2, setModu2] = useState(0);
  const [modu3, setModu3] = useState(0);
  const [modu4, setModu4] = useState(0);
  const [modu5, setModu5] = useState(0);
  const [modu6, setModu6] = useState(0);
  const [modu7, setModu7] = useState(0);
  const [modu8, setModu8] = useState(0);
  const [modu9, setModu9] = useState(0);
  const [modu10, setModu10] = useState(0);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [body, setBody] = useState({});
  const [essupervisor, setEssupervisor] = useState(0);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [perusu, setPerusu] = useState("0000");
  const [msg2, setMsg2] = useState();
  const [password, setPassword] = useState("");
  const [activate, setActivate] = useState(false);
  const [usuario, setUsuario] = useState();
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const cmbCedula = [
    { value: "V" },
    { value: "E" },
    { value: "J" },
    { value: "P" },
    { value: "G" },
  ];
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [mostrarClavesup, setMostrarClavesup] = useState(false);
  const [correo, setCorreo] = useState("");
  const [modulosConfig, setModulosConfig] = useState({
    opcion1: "",
    opcion2: "",
    opcion3: "",
    opcion4: "",
    opcion5: "",
    opcion6: "",
    opcion7: "",
  });
  const [modulosini, setModulosini] = useState({
    moduini: null
  });
  const [permisos, setPermisos] = useState({
    acccontribuyente: "0000",
    accactividad: "0000",
    accdeclaraciones: "000",
    accacticontri: "00",
    accagente: "0000",
    accusuariocome: "0000",
  });

  const [operacionesMod, setOperacionesMod] = useState({
    personas1: " ",
    personas2: " ",
    personas3: " ",
    personas4: " ",
    usuarios1: " ",
    usuarios2: " ",
    usuarios3: " ",
    usuarios4: " ",
    usuarioapp1: "",
    usuarioapp2: "",
    usuarioapp3: "",
    usuarioapp4: "",
    unidadcontable1: " ",
    unidadcontable2: " ",
    unidadcontable3: " ",
    unidadcontable4: " ",
    valorute1: " ",
    valorute2: " ",
    valorute3: " ",
    valorute4: " ",
    porcentaje1: " ",
    porcentaje2: " ",
    porcentaje3: " ",
    porcentaje4: " ",
    usuarioweb1: " ",
    usuarioweb2: " ",
    usuarioweb3: " ",
    usuarioweb4: " ",
    usuarioapp1: " ",
    usuarioapp2: " ",
    usuarioapp3: " ",
    usuarioapp4: " ",
    organizacion1: " ",
    organizacion2: " ",
    organizacion3: " ",
    organizacion4: " ",
  });

  const [moduloinventario, setModuloinventario] = useState({
    inve1: null,
    inve2: null,
    inve3: null,
    inve4: null,
    inve5: null,
    inve6: null,
    inve7: null,
    inve8: null,
    inve9: null,
    inve10: null,
    inve11: null,
    inve12: null,
  });
  const [moduloventas, setModuloventas] = useState({
    vents1: null,
    vents2: null,
    vents3: null,
    vents4: null,
    vents5: null,
    vents6: null,
    vents7: null,
    vents8: null,
    vents9: null,
    vents10: null
  });
  const [modulocompras, setModulocompras] = useState({
    mcompras1: null,
    mcompras2: null,
    mcompras3: null,
    mcompras4: null,
    mcompras5: null,
  });
  const [modulovacios, setModulovacios] = useState({
    vacios1: null,
    vacios2: null,
    vacios3: null,
    vacios4: null,
    vacios5: null,
  });
  const [moduloservicios, setModuloservicios] = useState({
    servicio1: null,
    servicio2: null,
    servicio3: null,
    servicio4: null,
    servicio5: null,
    servicio6: null,
  });
  const [modulopostventa, setModulopostventa] = useState({
    postventa1: null,
    postventa2: null,
    postventa3: null,
    postventa4: null,
    postventa5: null,
    postventa6: null,
  });
  const [modulocontabilidad, setModulocontabilidad] = useState({
    mcontab1: null,
    mcontab2: null,
    mcontab3: null,
    mcontab4: null,
    mcontab5: null,
    mcontab6: null,
  });
  const [modulofinanzas, setModulofinanzas] = useState({
    mfinanzas1: null,
    mfinanzas2: null,
    mfinanzas3: null,
    mfinanzas4: null,
    mfinanzas5: null,
    mfinanzas6: null,
    mfinanzas7: null,
    mfinanzas8: null,
    mfinanzas9: null,
    mfinanzas10: null,
    mfinanzas11: null,
    mfinanzas12: null,
  });

  const [url, setUrl] = useState("");

  let op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");

  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    sessionStorage.getItem("fechasistema")
  );
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtPasswordsuv = useRef();
  const txtConfirmPassword = useRef();
  const txtIdAgente = useRef();
  const txtNombreAgente = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const cmbStatus = useRef();

  useEffect(() => {
    let obj = JSON.parse(sessionStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }

    if (op.reportes != null) {
      setUrl(op.reportes.trim());
    } else {
      setUrl("");
    }
  }, [props.operacion]);

  const SelectUsuario = (idusuario) => {
    let endpoint = `${op.conexion}/api/athos/usuario/getuser?id=${idusuario}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {
            let orgaz = response.data.accconfiggene;

            let inv = response.data.accinventario;
            let vntas = response.data.accventas;
            let cmpras = response.data.acccompras;
            let cntbild = response.data.acccontabilidad;
            let finazs = response.data.accfinanzas;
            let aplic = response.data.accaplicaciones;
            let vaci = response.data.accvacios;
            let servi = response.data.accservicios;
            let postvent = response.data.accpostventas;
            let perinicio = response.data.accinicio;
            let tipoprec = response.data.tipoprecio;

            let btn1 = response.data.accbtnregalmacen;
            let btn2 = response.data.accbtnubialmacen;
            let btn3 = response.data.accbtnumedida;
            let btn4 = response.data.accbtnmarca;
            let btn5 = response.data.accbtnmodelo;
            let btn6 = response.data.accbtntproducto;
            let btn7 = response.data.accbtnproducto;
            let btn8 = response.data.accbtnopinventario;
            let btn9 = response.data.accbtnactxlsx;
            let btn10 = response.data.accbtntvacios;
            let btn11 = response.data.accbtnireports;
            let btn12 = response.data.accbtnclientes;
            let btn13 = response.data.accbtnvendedor;
            let btn14 = response.data.accbtnpedidos;
            let btn15 = response.data.accbtnnentrega;
            let btn16 = response.data.accbtnndebito;
            let btn17 = response.data.accbtnfacturas;
            let btn18 = response.data.accbtnpresupuesto;
            let btn19 = response.data.accbtnvreports;
            let btn20 = response.data.accbtnproveedores;
            let btn21 = response.data.accbtnordencompra;
            let btn22 = response.data.accbtnfactucompra;
            let btn23 = response.data.accbtncreports;
            let btn24 = response.data.accbtncntcontable;
            let btn25 = response.data.accbtnastcntable;
            let btn26 = response.data.accbtnmvbancarios;
            let btn27 = response.data.accbtnmvbancariost;
            let btn28 = response.data.accbtnvinculacuenta;
            let btn29 = response.data.accbtncntreports;
            let btn30 = response.data.accbtnbancos;
            let btn31 = response.data.accbtnbeneficiarios;
            let btn32 = response.data.accbtnctsbancarias;
            let btn33 = response.data.accbtncnciliabancaria;
            let btn34 = response.data.accbtncntxcobrar;
            let btn35 = response.data.accbtncntxpagar;
            let btn36 = response.data.accbtntipretenciones;
            let btn37 = response.data.accbtnfreports;
            let btn38 = response.data.btnopvacios;
            let btn39 = response.data.btncontvacios;
            let btn40 = response.data.btnclasvacios;
            let btn41 = response.data.btnreportvacios;
            let btn42 = response.data.btnreportserv;
            let btn43 = response.data.ordservicios;
            let btn44 = response.data.accmoviles;
            let btn45 = response.data.accgservicios;
            let btn46 = response.data.accservnota;
            let btn47 = response.data.postventa;
            let btn48 = response.data.accbtnfacturaxnotas;

            sessionStorage.setItem("accconfiggene", JSON.stringify(orgaz));

            sessionStorage.setItem("accinventarioc", JSON.stringify(inv));
            sessionStorage.setItem("accventasc", JSON.stringify(vntas));
            sessionStorage.setItem("acccomprasc", JSON.stringify(cmpras));
            sessionStorage.setItem("acccontabilidadc", JSON.stringify(cntbild));
            sessionStorage.setItem("accfinanzasc", JSON.stringify(finazs));
            sessionStorage.setItem("permisos", JSON.stringify(aplic));
            sessionStorage.setItem("accvaciosc", JSON.stringify(vaci));
            sessionStorage.setItem("accserviciosc", JSON.stringify(servi));
            sessionStorage.setItem("accpostventasc", JSON.stringify(postvent));
            sessionStorage.setItem("accinicioc", JSON.stringify(perinicio));

            sessionStorage.setItem("accbtnregalmacenc", JSON.stringify(btn1));
            sessionStorage.setItem("accbtnubialmacenc", JSON.stringify(btn2));
            sessionStorage.setItem("accbtnumedidac", JSON.stringify(btn3));
            sessionStorage.setItem("accbtnmarcac", JSON.stringify(btn4));
            sessionStorage.setItem("accbtnmodeloc", JSON.stringify(btn5));
            sessionStorage.setItem("accbtntproductoc", JSON.stringify(btn6));
            sessionStorage.setItem("accbtnproductoc", JSON.stringify(btn7));
            sessionStorage.setItem("accbtnopinventarioc", JSON.stringify(btn8));
            sessionStorage.setItem("accbtnactxlsxc", JSON.stringify(btn9));
            sessionStorage.setItem("accbtntvaciosc", JSON.stringify(btn10));
            sessionStorage.setItem("accbtnireportsc", JSON.stringify(btn11));
            sessionStorage.setItem("accbtnclientesc", JSON.stringify(btn12));
            sessionStorage.setItem("accbtnvendedorc", JSON.stringify(btn13));
            sessionStorage.setItem("accbtnpedidosc", JSON.stringify(btn14));
            sessionStorage.setItem("accbtnnentregac", JSON.stringify(btn15));
            sessionStorage.setItem("accbtnndebitoc", JSON.stringify(btn16));
            sessionStorage.setItem("accbtnfacturasc", JSON.stringify(btn17));
            sessionStorage.setItem("accbtnpresupuestoc", JSON.stringify(btn18));
            sessionStorage.setItem("accbtnvreportsc", JSON.stringify(btn19));
            sessionStorage.setItem("accbtnproveedoresc", JSON.stringify(btn20));
            sessionStorage.setItem("accbtnordencomprac", JSON.stringify(btn21));
            sessionStorage.setItem("accbtnfactucomprac", JSON.stringify(btn22));
            sessionStorage.setItem("accbtncreportsc", JSON.stringify(btn23));
            sessionStorage.setItem("accbtncntcontablec", JSON.stringify(btn24));
            sessionStorage.setItem("accbtnastcntablec", JSON.stringify(btn25));
            sessionStorage.setItem("accbtnmvbancariosc", JSON.stringify(btn26));
            sessionStorage.setItem("accbtnmvbancariostc", JSON.stringify(btn27));
            sessionStorage.setItem("accbtnvinculacuentac", JSON.stringify(btn28));
            sessionStorage.setItem("accbtncntreportsc", JSON.stringify(btn29));
            sessionStorage.setItem("accbtnbancosc", JSON.stringify(btn30));
            sessionStorage.setItem("accbtnbeneficiariosc", JSON.stringify(btn31));
            sessionStorage.setItem("accbtnctsbancariasc", JSON.stringify(btn32));
            sessionStorage.setItem("accbtnfacturaxnotasc", JSON.stringify(btn48));
            sessionStorage.setItem(
              "accbtncnciliabancariac",
              JSON.stringify(btn33)
            );
            sessionStorage.setItem("accbtncntxcobrarc", JSON.stringify(btn34));
            sessionStorage.setItem("accbtncntxpagarc", JSON.stringify(btn35));
            sessionStorage.setItem(
              "accbtntipretencionesc",
              JSON.stringify(btn36)
            );
            sessionStorage.setItem("accbtnfreportsc", JSON.stringify(btn37));
            sessionStorage.setItem("btnopvaciosc", JSON.stringify(btn38));
            sessionStorage.setItem("btncontvaciosc", JSON.stringify(btn39));
            sessionStorage.setItem("btnclasvaciosc", JSON.stringify(btn40));
            sessionStorage.setItem("btnreportvaciosc", JSON.stringify(btn41));
            sessionStorage.setItem("ordserviciosc", JSON.stringify(btn42));
            sessionStorage.setItem("btnreportservc", JSON.stringify(btn43));
            sessionStorage.setItem("accmovilesc", JSON.stringify(btn44));
            sessionStorage.setItem("accgserviciosc", JSON.stringify(btn45));
            sessionStorage.setItem("accservnotac", JSON.stringify(btn46));
            sessionStorage.setItem("postventac", JSON.stringify(btn47));
            sessionStorage.setItem("post", JSON.stringify({ tipoprecio: tipoprec }));
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Error al cargar el usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/athos/usuario/actualizar/${operacion}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);

          if (operacion === 1 || operacion === 2) {
            if (parseInt(response.data.iduser) > 0) {
              if (parseInt(response.data.iduser) === parseInt(idusuario)) {
                SelectUsuario(parseInt(response.data.iduser));
              }
            }
          }

          var mensaje = "";
          if (operacion === 1) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido registrada de manera satisfactoria.";
          } else if (operacion === 2) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido modificada de manera satisfactoria.";
          } else if (operacion === 3) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido eliminada de manera satisfactoria.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              setTabIndex1(0);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (values) => {
    setMostrar3(false);
    txtCedula.current.value = values.cedPer;
    txtNombreUsuario.current.value = values.nomPer;
    txtApellidoUsuario.current.value = values.apePer;
    txtDireccionUsuario.current.value = values.direPer;
    txtEmailUsuario.current.value = values.correoPer;
    txtTlfUsuario.current.value = values.tlf1Per;
    txtCelUsuario.current.value = values.tlf2Per;
    txtFechaNac.current.value = moment(values.fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = values.nacPer;
    cmbSexo.current.value = values.sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaCatalogoOrg = (values) => {
    setMostrar(false);
    txtIdAgente.current.value = values.idorganizacion;
    txtNombreAgente.current.value = values.nombre;
    txtCedula.current.focus();
  };

  const blanquear = () => {
    setPassword("");
    setActivate(false);
    setCorreo("");
    setOperacionPer(0);
    setEssupervisor(0);
    setPermisos({
      acccontribuyente: "0000",
      accactividad: "0000",
      accdeclaraciones: "000",
      accacticontri: "00",
      accagente: "0000",
      accusuariocome: "0000",
    });
    setModu1(0);
    setModu2(0);
    setModu3(0);
    setModu4(0);
    setModu5(0);
    setModu6(0);
    setModu7(0);
    setModu8(0);
    setModu9(0);
    setModu10(0);
    setModulopostventa("");
    setModuloventas("");
    setModulocompras("");
    setModulovacios("");
    setModuloservicios("");
    setModulocontabilidad("");
    setModulofinanzas("");
    setModulosini("");
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleChangeOtro = (event) => {
    if (event.target.name === "permodtimbre") {
      if (moduinventariosi.current.checked) {
        setModuloinventario({
          inve1: "0",
          inve2: "0",
          inve3: "0",
          inve4: "0",
          inve5: "0",
          inve6: "0",
          inve7: "0",
          inve8: "0",
          inve9: "0",
          inve10: "0",
          inve11: "0",
          inve12: "0",
        });
        setModu1(1);
      } else if (moduinventariono.current.checked) {
        setModuloinventario({
          inve1: "0",
          inve2: "0",
          inve3: "0",
          inve4: "0",
          inve5: "0",
          inve6: "0",
          inve7: "0",
          inve8: "0",
          inve9: "0",
          inve10: "0",
          inve11: "0",
          inve12: "0",
        });
        setModu1(0);
      }
    } else if (event.target.name === "permodminas") {
      if (event.target.value === "true") {
        setModuloventas({
          vents1: "0",
          vents2: "0",
          vents3: "0",
          vents4: "0",
          vents5: "0",
          vents6: "0",
          vents7: "0",
          vents8: "0",
          vents9: "0",
        });
        setModu2(1);
      } else if (event.target.value === "false") {
        setModuloventas({
          vents1: "0",
          vents2: "0",
          vents3: "0",
          vents4: "0",
          vents5: "0",
          vents6: "0",
          vents7: "0",
          vents8: "0",
          vents9: "0",
        });
        setModu2(0);
      }
    } else if (event.target.name === "permod1x500") {
      if (event.target.value === "true") {
        setModulocompras({
          mcompras1: "0",
          mcompras2: "0",
          mcompras3: "0",
          mcompras4: "0",
          mcompras5: "0",
        });
        setModu3(1);
      } else if (event.target.value === "false") {
        setModulocompras({
          mcompras1: "0",
          mcompras2: "0",
          mcompras3: "0",
          mcompras4: "0",
          mcompras5: "0",
        });
        setModu3(0);
      }
    } else if (event.target.name === "permodprod") {
      if (event.target.value === "true") {
        setModulocontabilidad({
          mcontab1: "0",
          mcontab2: "0",
          mcontab3: "0",
          mcontab4: "0",
          mcontab5: "0",
          mcontab6: "0",
        });
        setModu4(1);
      } else if (event.target.value === "false") {
        setModulocontabilidad({
          mcontab1: "0",
          mcontab2: "0",
          mcontab3: "0",
          mcontab4: "0",
          mcontab5: "0",
          mcontab6: "0",
        });
        setModu4(0);
      }
    } else if (event.target.name === "permodfiscal") {
      if (event.target.value === "true") {
        setModulofinanzas({
          mfinanzas1: "0",
          mfinanzas2: "0",
          mfinanzas3: "0",
          mfinanzas4: "0",
          mfinanzas5: "0",
          mfinanzas6: "0",
          mfinanzas7: "0",
          mfinanzas8: "0",
          mfinanzas9: "0",
          mfinanzas10: "0",
          mfinanzas11: "0",
          mfinanzas12: "0",
        });
        setModu5(1);
      } else if (event.target.value === "false") {
        setModulofinanzas({
          mfinanzas1: "0",
          mfinanzas2: "0",
          mfinanzas3: "0",
          mfinanzas4: "0",
          mfinanzas5: "0",
          mfinanzas6: "0",
          mfinanzas7: "0",
          mfinanzas8: "0",
          mfinanzas9: "0",
          mfinanzas10: "0",
          mfinanzas11: "0",
          mfinanzas12: "0",
        });
        setModu5(0);
      }
    } else if (event.target.name === "vacios") {
      if (event.target.value === "true") {
        setModulovacios({
          vacios1: "0",
          vacios2: "0",
          vacios3: "0",
          vacios4: "0",
          vacios5: "0",
        });
        setModu7(1);
      } else if (event.target.value === "false") {
        setModulovacios({
          vacios1: "0",
          vacios2: "0",
          vacios3: "0",
          vacios4: "0",
          vacios5: "0",
        });
        setModu7(0);
      }
    } else if (event.target.name === "servicios") {
      if (event.target.value === "true") {
        setModuloservicios({
          servicio1: "0",
          servicio2: "0",
          servicio3: "0",
          servicio4: "0",
          servicio5: "0",
          servicio6: "0"
        });
        setModu8(1);
      } else if (event.target.value === "false") {
        setModuloservicios({
          servicio1: "0",
          servicio2: "0",
          servicio3: "0",
          servicio4: "0",
          servicio5: "0"
        });
        setModu8(0);
      }
    } else if (event.target.name === 'ptventa') {
      if (event.target.value === "true") {
        setModulopostventa({
          postventa1: "0",
          postventa2: "0",
          postventa3: "0",
          postventa4: "0",
          postventa5: "0"
        });
        setModu9(1);
      } else if (event.target.value === "false") {
        setModulopostventa({
          postventa1: "0",
          postventa2: "0",
          postventa3: "0",
          postventa4: "0",
          postventa5: "0"
        });
        setModu9(0);
      }
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtConfirmPassword.current.focus();
        } else {
          txtIdAgente.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const seleccionarVendedor = (rif, desde) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = desde === 1 ? "idagente" : "rif";
    let nomid2 = "vendedor";
    let id = rif;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data !== "") {
          txtIdVendedor.current.value = response.data.idagente;
          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
          txtRif.current.value = response.data.rif.trim().substring(1, 10);
          txtRazon.current.value = response.data.nombre.trim();
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    txtIdVendedor.current.value = "";
    txtRazon.current.value = "";
    seleccionarVendedor(values.rif.trim(), 2);
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        txtIdVendedor.current.value = "";
        txtRazon.current.value = "";
        seleccionarVendedor(rif, 2);
      }
    }
  };

  const checkTodo = (event) => {
    if (event.target.name === "todopersonas") {
      if (chkPerTodo.current.checked) {
        chkPerCon.current.checked = true;
        chkPerIn.current.checked = true;
        chkPerMod.current.checked = true;
        chkPerEli.current.checked = true;
      } else {
        chkPerCon.current.checked = false;
        chkPerIn.current.checked = false;
        chkPerMod.current.checked = false;
        chkPerEli.current.checked = false;
      }
    } else if (event.target.name === "todousuarios") {
      if (chkUsuTodo.current.checked) {
        chkUsuCon.current.checked = true;
        chkUsuIn.current.checked = true;
        chkUsuMod.current.checked = true;
        chkUsuEli.current.checked = true;
      } else {
        chkUsuCon.current.checked = false;
        chkUsuIn.current.checked = false;
        chkUsuMod.current.checked = false;
        chkUsuEli.current.checked = false;
      }
    } else if (event.target.name === "todousuariosapp") {
      if (chkUsuappTodo.current.checked) {
        chkUsuappCon.current.checked = true;
        chkUsuappIn.current.checked = true;
        chkUsuappMod.current.checked = true;
        chkUsuappEli.current.checked = true;
      } else {
        chkUsuappCon.current.checked = false;
        chkUsuappIn.current.checked = false;
        chkUsuappMod.current.checked = false;
        chkUsuappEli.current.checked = false;
      }
    } else if (event.target.name === "todomonedas") {
      if (chkMoneTodo.current.checked) {
        chkMoneCon.current.checked = true;
        chkMoneIn.current.checked = true;
        chkMoneMod.current.checked = true;
        chkMoneEli.current.checked = true;
      } else {
        chkMoneCon.current.checked = false;
        chkMoneIn.current.checked = false;
        chkMoneMod.current.checked = false;
        chkMoneEli.current.checked = false;
      }
    } else if (event.target.name === "todoporcentaje") {
      if (chkPorTodo.current.checked) {
        chkPorCon.current.checked = true;
        chkPorIn.current.checked = true;
        chkPorMod.current.checked = true;
        chkPorEli.current.checked = true;
      } else {
        chkPorCon.current.checked = false;
        chkPorIn.current.checked = false;
        chkPorMod.current.checked = false;
        chkPorEli.current.checked = false;
      }
    } else if (event.target.name === "todouserweb") {
      if (chkUWebTodo.current.checked) {
        /*   chkUWebCon.current.checked = true; */
        chkUWebIn.current.checked = true;
        chkUWebMod.current.checked = true;
        /*    chkUWebEli.current.checked = true; */
      } else {
        chkUWebCon.current.checked = false;
        chkUWebIn.current.checked = false;
        chkUWebMod.current.checked = false;
        chkUWebEli.current.checked = false;
      }
    } else if (event.target.name === "todoapp") {
      if (chkUAppTodo.current.checked) {
        chkUAppCon.current.checked = true;
        chkUAppIn.current.checked = true;
        chkUAppMod.current.checked = true;
        chkUAppEli.current.checked = true;
      } else {
        chkUAppCon.current.checked = false;
        chkUAppIn.current.checked = false;
        chkUAppMod.current.checked = false;
        chkUAppEli.current.checked = false;
      }
    } else if (event.target.name === "todoorg") {
      if (chkOrgTodo.current.checked) {
        chkOrgCon.current.checked = true;
        chkOrgIn.current.checked = true;
        chkOrgMod.current.checked = true;
        chkOrgEli.current.checked = true;
      } else {
        chkOrgCon.current.checked = false;
        chkOrgIn.current.checked = false;
        chkOrgMod.current.checked = false;
        chkOrgEli.current.checked = false;
      }
    } else if (event.target.name === "todosinventario") {
      if (chkitodos.current.checked) {
        chkralmacen.current.checked = true;
        chkubialmacen.current.checked = true;
        chkudmedida.current.checked = true;
        chkmarca.current.checked = true;
        chkmodelo.current.checked = true;
        chktpproduct.current.checked = true;
        chkproducto.current.checked = true;
        chkopinventario.current.checked = true;
        chkactxlsx.current.checked = true;
        chkgvacios.current.checked = true;
        chkiconfigura.current.checked = true;
        chkireports.current.checked = true;
      } else {
        chkralmacen.current.checked = false;
        chkubialmacen.current.checked = false;
        chkudmedida.current.checked = false;
        chkmarca.current.checked = false;
        chkmodelo.current.checked = false;
        chktpproduct.current.checked = false;
        chkproducto.current.checked = false;
        chkopinventario.current.checked = false;
        chkactxlsx.current.checked = false;
        chkgvacios.current.checked = false;
        chkiconfigura.current.checked = false;
        chkireports.current.checked = false;
      }
    } else if (event.target.name === "todosventas") {
      if (chkvtodos.current.checked) {
        chkclientes.current.checked = true;
        chkvendedores.current.checked = true;
        chkpedidos.current.checked = true;
        chknentrega.current.checked = true;
        chkndebito.current.checked = true;
        chkfactura.current.checked = true;
        chkpresupuesto.current.checked = true;
        chkvconfi.current.checked = true;
        chkvreports.current.checked = true;
        chkfacturaxnotas.current.checked = true;
      } else {
        chkclientes.current.checked = false;
        chkvendedores.current.checked = false;
        chkpedidos.current.checked = false;
        chknentrega.current.checked = false;
        chkndebito.current.checked = false;
        chkfactura.current.checked = false;
        chkpresupuesto.current.checked = false;
        chkvconfi.current.checked = false;
        chkvreports.current.checked = false;
        chkfacturaxnotas.current.checked = false;
      }
    } else if (event.target.name === "todoscompras") {
      if (chkcptodos.current.checked) {
        chkproveedores.current.checked = true;
        chkordencompra.current.checked = true;
        chkfactucompra.current.checked = true;
        chkcpconfig.current.checked = true;
        chkcpreports.current.checked = true;
      } else {
        chkproveedores.current.checked = false;
        chkordencompra.current.checked = false;
        chkfactucompra.current.checked = false;
        chkcpconfig.current.checked = false;
        chkcpreports.current.checked = false;
      }
    } else if (event.target.name === "todoscontabilidad") {
      if (chkcnttodos.current.checked) {
        chkcatctcontable.current.checked = true;
        chkasientcntable.current.checked = true;
        chkvincuenta.current.checked = true;
        chkmovibancot.current.checked = true;
        chkcntconfig.current.checked = true;
        chkcntreports.current.checked = true;
      } else {
        chkcatctcontable.current.checked = false;
        chkasientcntable.current.checked = false;
        chkvincuenta.current.checked = false;
        chkmovibancot.current.checked = false;
        chkcntconfig.current.checked = false;
        chkcntreports.current.checked = false;
      }
    } else if (event.target.name === "todosfinanzas") {
      if (chkftodos.current.checked) {
        chkbancos.current.checked = true;
        chkbeneficiarios.current.checked = true;
        chkctasbancarias.current.checked = true;
        chkmovibancarios.current.checked = true;
        chkmovitransito.current.checked = true;
        chkconciliacionbanco.current.checked = true;
        chkctasxcobrar.current.checked = true;
        chkctasxpagar.current.checked = true;
        chktiporetenciones.current.checked = true;
        chkfconfig.current.checked = true;
        chkfreports.current.checked = true;
        chkReverPagoAnti.current.checked = true;
      } else {
        chkbancos.current.checked = false;
        chkbeneficiarios.current.checked = false;
        chkctasbancarias.current.checked = false;
        chkmovibancarios.current.checked = false;
        chkmovitransito.current.checked = false;
        chkconciliacionbanco.current.checked = false;
        chkctasxcobrar.current.checked = false;
        chkctasxpagar.current.checked = false;
        chktiporetenciones.current.checked = false;
        chkfconfig.current.checked = false;
        chkfreports.current.checked = false;
        chkReverPagoAnti.current.checked = false;

      }
    } else if (event.target.name === "todosvacios") {
      if (chkvaciostodos.current.checked) {
        chkopvacios.current.checked = true;
        chkcontrolvacios.current.checked = true;
        chkclassvacios.current.checked = true;
        chkvaciosconfig.current.checked = true;
        chkvaciosreports.current.checked = true;
      } else {
        chkopvacios.current.checked = false;
        chkcontrolvacios.current.checked = false;
        chkclassvacios.current.checked = false;
        chkvaciosconfig.current.checked = false;
        chkvaciosreports.current.checked = false;
      }
    } else if (event.target.name === "todosservicios") {
      if (chkservtodos.current.checked) {
        chkordenservi.current.checked = true;
        chkservconfig.current.checked = true;
        chkservreports.current.checked = true;
        chkmovilesservi.current.checked = true;
        chkgservicios.current.checked = true;
        chkservnotaent.current.checked = true;
      } else {
        chkordenservi.current.checked = false;
        chkservconfig.current.checked = false;
        chkservreports.current.checked = false;
        chkmovilesservi.current.checked = false;
        chkgservicios.current.checked = false;
        chkservnotaent.current.checked = false;
      }
    } else if (event.target.name === "todospostventa") {
      if (chkpostventtodos.current.checked) {
        chkpostventventa.current.checked = true;
      } else {
        chkpostventventa.current.checked = false;
      }
    }
  };

  const checkBlank = (e) => {
    if (modu1 === 1) {
      if (
        chkralmacen.current.checked &&
        chkubialmacen.current.checked &&
        chkudmedida.current.checked &&
        chkmarca.current.checked &&
        chkmodelo.current.checked &&
        chktpproduct.current.checked &&
        chkproducto.current.checked &&
        chkopinventario.current.checked &&
        chkactxlsx.current.checked &&
        chkgvacios.current.checked &&
        chkiconfigura.current.checked &&
        chkireports.current.checked
      ) {
        chkitodos.current.checked = true;
      } else {
        chkitodos.current.checked = false;
      }
    }

    if (modulosConfig.opcion2 === "1") {
      if (
        chkPerCon.current.checked &&
        chkPerIn.current.checked &&
        chkPerMod.current.checked &&
        chkPerEli.current.checked
      ) {
        chkPerTodo.current.checked = true;
      } else {
        chkPerTodo.current.checked = false;
      }
    }

    if (modulosConfig.opcion3 === "1") {
      if (
        chkUsuCon.current.checked &&
        chkUsuIn.current.checked &&
        chkUsuMod.current.checked &&
        chkUsuEli.current.checked
      ) {
        chkUsuTodo.current.checked = true;
      } else {
        chkUsuTodo.current.checked = false;
      }
    }

    if (modulosConfig.opcion6 === "1") {
      if (
        chkUsuappCon.current.checked &&
        chkUsuappIn.current.checked &&
        chkUsuappMod.current.checked &&
        chkUsuappEli.current.checked
      ) {
        chkUsuappTodo.current.checked = true;
      } else {
        chkUsuappTodo.current.checked = false;
      }
    }

    if (modulosConfig.opcion4 === "1") {
      if (
        chkMoneCon.current.checked &&
        chkMoneIn.current.checked &&
        chkMoneMod.current.checked &&
        chkMoneEli.current.checked
      ) {
        chkMoneTodo.current.checked = true;
      } else {
        chkMoneTodo.current.checked = false;
      }
    }

    if (
      chkclientes.current.checked &&
      chkvendedores.current.checked &&
      chkpedidos.current.checked &&
      chknentrega.current.checked &&
      chkndebito.current.checked &&
      chkfactura.current.checked &&
      chkfacturaxnotas.current.checked &&
      chkpresupuesto.current.checked &&
      chkvconfi.current.checked &&
      chkvreports.current.checked
    ) {
      chkvtodos.current.checked = true;
    } else {
      chkvtodos.current.checked = false;
    }

    if (
      chkproveedores.current.checked &&
      chkordencompra.current.checked &&
      chkfactucompra.current.checked &&
      chkcpconfig.current.checked &&
      chkcpreports.current.checked
    ) {
      chkcptodos.current.checked = true;
    } else {
      chkcptodos.current.checked = false;
    }

    if (
      chkcatctcontable.current.checked &&
      chkasientcntable.current.checked &&
      chkvincuenta.current.checked &&
      chkmovibancot.current.checked &&
      chkcntconfig.current.checked &&
      chkcntreports.current.checked
    ) {
      chkcnttodos.current.checked = true;
    } else {
      chkcnttodos.current.checked = false;
    }

    if (
      chkbancos.current.checked === true &&
      chkbeneficiarios.current.checked === true &&
      chkctasbancarias.current.checked === true &&
      chkmovibancarios.current.checked === true &&
      chkmovitransito.current.checked === true &&
      chkconciliacionbanco.current.checked === true &&
      chkctasxcobrar.current.checked === true &&
      chkctasxpagar.current.checked === true &&
      chktiporetenciones.current.checked === true &&
      chkfconfig.current.checked === true &&
      chkfreports.current.checked === true &&
      chkReverPagoAnti.current.checked === true
    ) {
      chkftodos.current.checked = true;
    } else {
      chkftodos.current.checked = false;
    }

    if (modu7 === 1) {
      if (
        chkopvacios.current.checked &&
        chkcontrolvacios.current.checked &&
        chkclassvacios.current.checked &&
        chkvaciosconfig.current.checked &&
        chkvaciosreports.current.checked
      ) {
        chkvaciostodos.current.checked = true;
      } else {
        chkvaciostodos.current.checked = false;
      }
    }

    if (modu8 === 1) {
      if (
        chkordenservi.current.checked &&
        chkservconfig.current.checked &&
        chkservreports.current.checked &&
        chkmovilesservi.current.checked &&
        chkgservicios.current.checked &&
        chkservnotaent.current.checked
      ) {
        chkservtodos.current.checked = true;
      } else {
        chkservtodos.current.checked = false;
      }
    }

    if (modu9 === 1) {
      if (chkpostventventa.current.checked) {
        chkpostventtodos.current.checked = true;
      } else {
        chkpostventtodos.current.checked = false;
      }
    }
    if (props.usuario && props.usuario.passwsupervisor !== false) {
      if (chksupervisor.current.checked === true) {
        setEssupervisor(1);
      } else {
        setEssupervisor(0);
      }
    }
  };

  const onChange = (e) => {
    if (e.target.id === "modulo") {
      setModulosConfig({ ...modulosConfig, [e.target.name]: e.target.value });
    }
  };

  const onChangeMonuini = (e) => {
    if (e.target.name === "inicio") {
      if (e.target.value === "1") {
        setModulosini({ moduini: e.target.value });
      } else {
        setModulosini({ moduini: e.target.value });
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosAgente(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";

    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&id=${idagente}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtNombreAgente.current.value = response.data.nombre;
            txtCedula.current.focus();
            setContar(contar + 1);
          } else {
            txtNombreAgente.current.value = "";
            txtIdAgente.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Agente no existe.",
              icono: "informacion",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let personas = "";
    let usuarios = "";
    let usuariosapp = "";
    let moneda = "";
    let minventario = "";
    let mventas = "";
    let mcompras = "";
    let mcontabilidad = "";
    let mfinanzas = "";
    let moduloss = "";
    let vacios = "";
    let servicios = "";
    let postventas = "";
    let permiinicio = "";

    let inv1 = "";
    let inv2 = "";
    let inv3 = "";
    let inv4 = "";
    let inv5 = "";
    let inv6 = "";
    let inv7 = "";
    let inv8 = "";
    let inv9 = "";
    let inv10 = "";
    let inv11 = "";

    let vent1 = "";
    let vent2 = "";
    let vent3 = "";
    let vent4 = "";
    let vent5 = "";
    let vent6 = "";
    let vent7 = "";
    let vent8 = "";
    let vent9 = "";

    let compr1 = "";
    let compr2 = "";
    let compr3 = "";
    let compr4 = "";

    let vacio1 = "";
    let vacio2 = "";
    let vacio3 = "";
    let vacio4 = "";

    let servicio1 = "";
    let servicio2 = "";
    let servicio3 = "";
    let servicio4 = "";
    let servicio5 = "";

    let postventa1 = "";
    let postventa2 = false;
    let postventa3 = "";
    let postventa4 = "";
    let postventa5 = "";

    let contb1 = "";
    let contb2 = "";
    let contb3 = "";
    let contb4 = "";
    let contb5 = "";

    let finaz1 = "";
    let finaz2 = "";
    let finaz3 = "";
    let finaz4 = "";
    let finaz5 = "";
    let finaz6 = "";
    let finaz7 = "";
    let finaz8 = "";
    let finaz9 = "";
    let finaz10 = "";

    if (modulosConfig.opcion2 === "1") {
      let permiso1 = chkPerCon.current.checked === true ? "1" : "0";
      let permiso2 = chkPerIn.current.checked === true ? "1" : "0";
      let permiso3 = chkPerMod.current.checked === true ? "1" : "0";
      let permiso4 = chkPerEli.current.checked === true ? "1" : "0";

      personas = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      personas = "0000";
    }

    if (modulosConfig.opcion3 === "1") {
      let permiso1 = chkUsuCon.current.checked === true ? "1" : "0";
      let permiso2 = chkUsuIn.current.checked === true ? "1" : "0";
      let permiso3 = chkUsuMod.current.checked === true ? "1" : "0";
      let permiso4 = chkUsuEli.current.checked === true ? "1" : "0";

      usuarios = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      usuarios = "0000";
    }

    if (modulosConfig.opcion6 === "1") {
      let permiso1 = chkUsuappCon.current.checked === true ? "1" : "0";
      let permiso2 = chkUsuappIn.current.checked === true ? "1" : "0";
      let permiso3 = chkUsuappMod.current.checked === true ? "1" : "0";
      let permiso4 = chkUsuappEli.current.checked === true ? "1" : "0";

      usuariosapp = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      usuariosapp = "0000";
    }

    if (modulosConfig.opcion4 === "1") {
      let permiso1 = chkMoneCon.current.checked === true ? "1" : "0";
      let permiso2 = chkMoneIn.current.checked === true ? "1" : "0";
      let permiso3 = chkMoneMod.current.checked === true ? "1" : "0";
      let permiso4 = chkMoneEli.current.checked === true ? "1" : "0";

      moneda = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      moneda = "0000";
    }

    if (
      aplica.toString().substring(0, 1) === "1" &&
      (operacion !== 4 && modu1 === 1) || operacion === 1 && modu1 === 1
    ) {
      let val1 = chkralmacen.current.checked === true ? "1" : "0";
      let val2 = chkubialmacen.current.checked === true ? "1" : "0";
      let val3 = chkudmedida.current.checked === true ? "1" : "0";
      let val4 = chkmarca.current.checked === true ? "1" : "0";
      let val5 = chkmodelo.current.checked === true ? "1" : "0";
      let val6 = chktpproduct.current.checked === true ? "1" : "0";
      let val7 = chkproducto.current.checked === true ? "1" : "0";
      let val8 = chkopinventario.current.checked === true ? "1" : "0";
      let val9 = chkactxlsx.current.checked === true ? "1" : "0";
      let val10 = chkgvacios.current.checked === true ? "1" : "0";
      let val11 = chkiconfigura.current.checked === true ? "1" : "0";
      let val12 = chkireports.current.checked === true ? "1" : "0";

      minventario =
        val1 +
        val2 +
        val3 +
        val4 +
        val5 +
        val6 +
        val7 +
        val8 +
        val9 +
        val10 +
        val11 +
        val12;

      if (val1 === "0") {
        inv1 = "000000";
      } else {
        if (operacion === 1) {
          inv1 = "000000";
        } else {
          inv1 = props.usuario.accbtnregalmacen;
        }
      }

      if (val2 === "0") {
        inv2 = "000000";
      } else {
        if (operacion === 1) {
          inv2 = "000000";
        } else {
          inv2 = props.usuario.accbtnubialmacen;
        }
      }

      if (val3 === "0") {
        inv3 = "000000";
      } else {
        if (operacion === 1) {
          inv3 = "000000";
        } else {
          inv3 = props.usuario.accbtnumedida;
        }
      }

      if (val4 === "0") {
        inv4 = "000000";
      } else {
        if (operacion === 1) {
          inv4 = "000000";
        } else {
          inv4 = props.usuario.accbtnmarca;
        }
      }

      if (val5 === "0") {
        inv5 = "000000";
      } else {
        if (operacion === 1) {
          inv5 = "000000";
        } else {
          inv5 = props.usuario.accbtnmodelo;
        }
      }

      if (val6 === "0") {
        inv6 = "000000";
      } else {
        if (operacion === 1) {
          inv6 = "000000";
        } else {
          inv6 = props.usuario.accbtntproducto;
        }
      }

      if (val7 === "0") {
        inv7 = "000000";
      } else {
        if (operacion === 1) {
          inv7 = "000000";
        } else {
          inv7 = props.usuario.accbtnproducto;
        }
      }

      if (val8 === "0") {
        inv8 = "000000";
      } else {
        if (operacion === 1) {
          inv8 = "000000";
        } else {
          inv8 = props.usuario.accbtnopinventario;
        }
      }

      if (val9 === "0") {
        inv9 = "000000";
      } else {
        if (operacion === 1) {
          inv9 = "000000";
        } else {
          inv9 = props.usuario.accbtnactxlsx;
        }
      }

      if (val10 === "0") {
        inv10 = "000000";
      } else {
        if (operacion === 1) {
          inv10 = "000000";
        } else {
          inv10 = props.usuario.accbtntvacios;
        }
      }

      if (val12 === "0") {
        inv11 = "000000";
      } else {
        if (operacion === 1) {
          inv11 = "000000";
        } else {
          inv11 = props.usuario.accbtnireports;
        }
      }
    } else {
      minventario = "000000000000";
      inv1 = "000000";
      inv2 = "000000";
      inv3 = "000000";
      inv4 = "000000";
      inv5 = "000000";
      inv6 = "000000";
      inv7 = "000000";
      inv8 = "000000";
      inv9 = "000000";
      inv10 = "000000";
      inv11 = "000000";
    }

    if (
      aplica.toString().substring(1, 2) === "1" &&
      (operacion !== 4 && modu2 === 1) || operacion === 1 && modu2 === 1
    ) {
      let val1 = chkclientes.current.checked === true ? "1" : "0";
      let val2 = chkvendedores.current.checked === true ? "1" : "0";
      let val3 = chkpedidos.current.checked === true ? "1" : "0";
      let val4 = chknentrega.current.checked === true ? "1" : "0";
      let val5 = chkndebito.current.checked === true ? "1" : "0";
      let val6 = chkfactura.current.checked === true ? "1" : "0";
      let val7 = chkpresupuesto.current.checked === true ? "1" : "0";
      let val8 = chkvconfi.current.checked === true ? "1" : "0";
      let val9 = chkvreports.current.checked === true ? "1" : "0";
      let val10 = chkfacturaxnotas.current.checked === true ? "1" : "0";

      mventas = val1 + val2 + val3 + val4 + val5 + val6 + val7 + val8 + val9 + val10;

      if (val1 === "0") {
        vent1 = "000000";
      } else {
        if (operacion === 1) {
          vent1 = "000000";
        } else {
          vent1 = props.usuario.accbtnclientes;
        }
      }

      if (val2 === "0") {
        vent2 = "000000";
      } else {
        if (operacion === 1) {
          vent2 = "000000";
        } else {
          vent2 = props.usuario.accbtnvendedor;
        }
      }

      if (val3 === "0") {
        vent3 = "000000";
      } else {
        if (operacion === 1) {
          vent3 = "000000";
        } else {
          vent3 = props.usuario.accbtnpedidos;
        }
      }

      if (val4 === "0") {
        vent4 = "000000";
      } else {
        if (operacion === 1) {
          vent4 = "000000";
        } else {
          vent4 = props.usuario.accbtnnentrega;
        }
      }

      if (val5 === "0") {
        vent5 = "000000";
      } else {
        if (operacion === 1) {
          vent5 = "000000";
        } else {
          vent5 = props.usuario.accbtnndebito;
        }
      }

      if (val6 === "0") {
        vent6 = "000000";
      } else {
        if (operacion === 1) {
          vent6 = "000000";
        } else {
          vent6 = props.usuario.accbtnfacturas;
        }
      }

      if (val7 === "0") {
        vent7 = "000000";
      } else {
        if (operacion === 1) {
          vent7 = "000000";
        } else {
          vent7 = props.usuario.accbtnpresupuesto;
        }
      }

      if (val9 === "0") {
        vent8 = "000000";
      } else {
        if (operacion === 1) {
          vent8 = "000000";
        } else {
          vent8 = props.usuario.accbtnvreports;
        }
      }

      if (val10 === "0") {
        vent9 = "000000";
      } else {
        if (operacion === 1) {
          vent9 = "000000";
        } else {
          vent9 = props.usuario.accbtnfacturaxnotas;
        }
      }
    } else {
      mventas = "000000000";
      vent1 = "000000";
      vent2 = "000000";
      vent3 = "000000";
      vent4 = "000000";
      vent5 = "000000";
      vent6 = "000000";
      vent7 = "000000";
      vent8 = "000000";
      vent9 = "000000";
    }

    if (
      aplica.toString().substring(2, 3) === "1" &&
      (operacion !== 4 && modu3 === 1) || operacion === 1 && modu3 === 1
    ) {
      let val1 = chkproveedores.current.checked === true ? "1" : "0";
      let val2 = chkordencompra.current.checked === true ? "1" : "0";
      let val3 = chkfactucompra.current.checked === true ? "1" : "0";
      let val4 = chkcpconfig.current.checked === true ? "1" : "0";
      let val5 = chkcpreports.current.checked === true ? "1" : "0";

      mcompras = val1 + val2 + val3 + val4 + val5;

      if (val1 === "0") {
        compr1 = "000000";
      } else {
        if (operacion === 1) {
          compr1 = "000000";
        } else {
          compr1 = props.usuario.accbtnproveedores;
        }
      }

      if (val2 === "0") {
        compr2 = "000000";
      } else {
        if (operacion === 1) {
          compr2 = "000000";
        } else {
          compr2 = props.usuario.accbtnordencompra;
        }
      }

      if (val3 === "0") {
        compr3 = "000000";
      } else {
        if (operacion === 1) {
          compr3 = "000000";
        } else {
          compr3 = props.usuario.accbtnfactucompra;
        }
      }

      if (val5 === "0") {
        compr4 = "000000";
      } else {
        if (operacion === 1) {
          compr4 = "000000";
        } else {
          compr4 = props.usuario.accbtncreports;
        }
      }
    } else {
      mcompras = "00000";
      compr1 = "000000";
      compr2 = "000000";
      compr3 = "000000";
      compr4 = "000000";
    }

    if (
      aplica.toString().substring(3, 4) === "1" &&
      (operacion !== 4 && modu4 === 1) || operacion === 1 && modu4 === 1
    ) {
      let val1 = chkcatctcontable.current.checked === true ? "1" : "0";
      let val2 = chkasientcntable.current.checked === true ? "1" : "0";
      let val3 = chkvincuenta.current.checked === true ? "1" : "0";
      let val4 = chkmovibancot.current.checked === true ? "1" : "0";
      let val5 = chkcntconfig.current.checked === true ? "1" : "0";
      let val6 = chkcntreports.current.checked === true ? "1" : "0";

      mcontabilidad = val1 + val2 + val3 + val4 + val5 + val6;

      if (val1 === "0") {
        contb1 = "000000";
      } else {
        if (operacion === 1) {
          contb1 = "000000";
        } else {
          contb1 = props.usuario.accbtncntcontable;
        }
      }

      if (val2 === "0") {
        contb2 = "000000";
      } else {
        if (operacion === 1) {
          contb2 = "000000";
        } else {
          contb2 = props.usuario.accbtnastcntable;
        }
      }

      if (val3 === "0") {
        contb3 = "000000";
      } else {
        if (operacion === 1) {
          contb3 = "000000";
        } else {
          contb3 = props.usuario.accbtnmvbancariost;
        }
      }

      if (val4 === "0") {
        contb4 = "000000";
      } else {
        if (operacion === 1) {
          contb4 = "000000";
        } else {
          contb4 = props.usuario.accbtnvinculacuenta;
        }
      }

      if (val6 === "0") {
        contb5 = "000000";
      } else {
        if (operacion === 1) {
          contb5 = "000000";
        } else {
          contb5 = props.usuario.accbtncntreports;
        }
      }
    } else {
      mcontabilidad = "000000";
      contb1 = "000000";
      contb2 = "000000";
      contb3 = "000000";
      contb4 = "000000";
      contb5 = "000000";
    }

    if (
      aplica.toString().substring(4, 5) === "1" &&
      (operacion !== 4 && modu5 === 1) || operacion === 1 && modu5 === 1
    ) {
      let val1 = chkbancos.current.checked === true ? "1" : "0";
      let val2 = chkbeneficiarios.current.checked === true ? "1" : "0";
      let val3 = chkctasbancarias.current.checked === true ? "1" : "0";
      let val4 = chkmovibancarios.current.checked === true ? "1" : "0";
      let val5 = chkmovitransito.current.checked === true ? "1" : "0";
      let val6 = chkconciliacionbanco.current.checked === true ? "1" : "0";
      let val7 = chkctasxcobrar.current.checked === true ? "1" : "0";
      let val8 = chkctasxpagar.current.checked === true ? "1" : "0";
      let val9 = chktiporetenciones.current.checked === true ? "1" : "0";
      let val10 = chkfconfig.current.checked === true ? "1" : "0";
      let val11 = chkfreports.current.checked === true ? "1" : "0";
      let val12 = chkReverPagoAnti.current.checked === true ? "1" : "0";

      mfinanzas =
        val1 +
        val2 +
        val3 +
        val4 +
        val5 +
        val6 +
        val7 +
        val8 +
        val9 +
        val10 +
        val11 + val12;

      if (val1 === "0") {
        finaz1 = "000000";
      } else {
        if (operacion === 1) {
          finaz1 = "000000";
        } else {
          finaz1 = props.usuario.accbtnmvbancarios;
        }
      }

      if (val2 === "0") {
        finaz2 = "000000";
      } else {
        if (operacion === 1) {
          finaz2 = "000000";
        } else {
          finaz2 = props.usuario.accbtnmvbancariost;
        }
      }

      if (val3 === "0") {
        finaz3 = "000000";
      } else {
        if (operacion === 1) {
          finaz3 = "000000";
        } else {
          finaz3 = props.usuario.accbtnbancos;
        }
      }

      if (val4 === "0") {
        finaz4 = "000000";
      } else {
        if (operacion === 1) {
          finaz4 = "000000";
        } else {
          finaz4 = props.usuario.accbtnbeneficiarios;
        }
      }

      if (val5 === "0") {
        finaz5 = "000000";
      } else {
        if (operacion === 1) {
          finaz5 = "000000";
        } else {
          finaz5 = props.usuario.accbtnctsbancarias;
        }
      }

      if (val6 === "0") {
        finaz6 = "000000";
      } else {
        if (operacion === 1) {
          finaz6 = "000000";
        } else {
          finaz6 = props.usuario.accbtncnciliabancaria;
        }
      }

      if (val7 === "0") {
        finaz7 = "000000";
      } else {
        if (operacion === 1) {
          finaz7 = "000000";
        } else {
          finaz7 = props.usuario.accbtncntxcobrar;
        }
      }

      if (val8 === "0") {
        finaz8 = "000000";
      } else {
        if (operacion === 1) {
          finaz8 = "000000";
        } else {
          finaz8 = props.usuario.accbtncntxpagar;
        }
      }

      if (val9 === "0") {
        finaz9 = "000000";
      } else {
        if (operacion === 1) {
          finaz9 = "000000";
        } else {
          finaz9 = props.usuario.accbtntipretenciones;
        }
      }

      if (val11 === "0") {
        finaz10 = "00000000";
      } else {
        if (operacion === 1) {
          finaz10 = "000000000";
        } else {
          finaz10 = props.usuario.accbtnfreports;
        }
      }
    } else {
      mfinanzas = "00000000000";
      finaz1 = "000000";
      finaz2 = "000000";
      finaz3 = "000000";
      finaz4 = "000000";
      finaz5 = "000000";
      finaz6 = "000000";
      finaz7 = "000000";
      finaz8 = "000000";
      finaz9 = "000000";
      finaz10 = "00000000";
    }

    if (aplica !== "00000000" || operacion === 1) {
      let val1 = moduinventariosi.current.checked === true ? "1" : "0";
      let val2 = moduventassi.current.checked === true ? "1" : "0";
      let val3 = moducomprassi.current.checked === true ? "1" : "0";
      let val4 = moducontabsi.current.checked === true ? "1" : "0";
      let val5 = modufinanzassi.current.checked === true ? "1" : "0";
      let val6 = moduconfigsi.current.checked === true ? "1" : "0";
      let val7 = moduvaciossi.current.checked === true ? "1" : "0";
      let val8 = moduserviciossi.current.checked === true ? "1" : "0";
      let val9 = modupostventasi.current.checked === true ? "1" : "0";

      moduloss = val1 + val2 + val3 + val4 + val5 + val6 + val7 + val8 + val9;
    } else {
      moduloss = "0000000000";
    }

    if (modulosini.moduini !== "" || operacion === 1) {
      let val1 = modulosini.moduini;
      permiinicio = val1;
    } else {
      permiinicio = "0";
    }

    if (
      aplica.toString().substring(6, 7) === "1" &&
      (operacion !== 4 && modu7 === 1) || operacion === 1 && modu7 === 1
    ) {
      let val1 = chkopvacios.current.checked === true ? "1" : "0";
      let val2 = chkcontrolvacios.current.checked === true ? "1" : "0";
      let val3 = chkclassvacios.current.checked === true ? "1" : "0";
      let val4 = chkvaciosconfig.current.checked === true ? "1" : "0";
      let val5 = chkvaciosreports.current.checked === true ? "1" : "0";

      vacios = val1 + val2 + val3 + val4 + val5;

      if (val1 === "0") {
        vacio1 = "000000";
      } else {
        if (operacion === 1) {
          vacio1 = "000000";
        } else {
          vacio1 = props.usuario.btnopvacios;
        }
      }

      if (val2 === "0") {
        vacio2 = "000000";
      } else {
        if (operacion === 1) {
          vacio2 = "000000";
        } else {
          vacio2 = props.usuario.btncontvacios;
        }
      }

      if (val3 === "0") {
        vacio3 = "000000";
      } else {
        if (operacion === 1) {
          vacio3 = "000000";
        } else {
          vacio3 = props.usuario.btnclasvacios;
        }
      }

      if (val5 === "0") {
        vacio4 = "000000";
      } else {
        if (operacion === 1) {
          vacio4 = "000000";
        } else {
          vacio4 = props.usuario.btnreportvacios;
        }
      }
    } else {
      vacios = "00000";
      vacio1 = "000000";
      vacio2 = "000000";
      vacio3 = "000000";
      vacio4 = "000000";
    }

    if (
      aplica.toString().substring(7, 8) === "1" &&
      (operacion !== 4 && modu8 === 1) || operacion === 1 && modu8 === 1
    ) {
      let val1 = chkordenservi.current.checked === true ? "1" : "0";
      let val2 = chkmovilesservi.current.checked === true ? "1" : "0";
      let val3 = chkgservicios.current.checked === true ? "1" : "0";
      let val4 = chkservnotaent.current.checked === true ? "1" : "0";
      let val5 = chkservconfig.current.checked === true ? "1" : "0";
      let val6 = chkservreports.current.checked === true ? "1" : "0";

      servicios = val1 + val2 + val3 + val4 + val5 + val6;

      if (val1 === "0") {
        servicio1 = "000000";
      } else {
        if (operacion === 1) {
          servicio1 = "000000";
        } else {
          servicio1 = props.usuario.ordservicios;
        }
      }

      if (val2 === "0") {
        servicio2 = "000000";
      } else {
        if (operacion === 1) {
          servicio2 = "000000";
        } else {
          servicio2 = props.usuario.accmoviles;
        }
      }

      if (val3 === "0") {
        servicio3 = "000000";
      } else {
        if (operacion === 1) {
          servicio3 = "000000";
        } else {
          servicio3 = props.usuario.accgservicios;
        }
      }

      if (val4 === "0") {
        servicio4 = "000000";
      } else {
        if (operacion === 1) {
          servicio4 = "000000";
        } else {
          servicio4 = props.usuario.accservnota;
        }
      }

      if (val6 === "0") {
        servicio5 = "000000";
      } else {
        if (operacion === 1) {
          servicio5 = "000000";
        } else {
          servicio5 = props.usuario.btnreportserv;
        }
      }
    } else {
      servicios = "00000";
      servicio1 = "000000";
      servicio2 = "000000";
      servicio3 = "000000";
      servicio4 = "000000";
      servicio5 = "000000";
    }

    if (
      aplica.toString().substring(8, 9) === "1" &&
      (operacion !== 4 && modu9 === 1) || operacion === 1 && modu9 === 1
    ) {
      let val1 = chkpostventventa.current.checked === true ? "1" : "0";
      postventa2 = chksupervisor.current.checked === true ? true : false;

      postventas = val1;

      if (val1 === "0") {
        postventa1 = "000000";
      } else {
        if (operacion === 1) {
          postventa1 = "000000";
        } else {
          postventa1 = props.usuario.postventa;
        }
      }

    } else {
      postventas = "00000";
      postventa1 = "000000";
    }

    var sigue = true;
    var mensaje = "";
    if (txtLogin.current.value.trim() === "") {
      mensaje = "El Usuario no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      mensaje = "La Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
      txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      mensaje = "Las Contraseñas no coinciden";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      mensaje = "La direccion del Usuario no debe estar vacia";
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var user = [];
      var datoPer = [];

      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        persona: txtCedula.current.value,
        status: cmbStatus.current.value,
        ...(props.menu !== "sistema" && {
          idagente: txtIdVendedor.current.value,
        }),
        ...(props.menu !== "sistema" && { numcaja: cmbCaja.current.value }),
        idorganizacion:
          props.menu === "sistema" ? txtIdAgente.current.value : idorganizacion,
        accaplicaciones: moduloss,
        accconfiggene:
          modulosConfig.opcion1 +
          modulosConfig.opcion2 +
          modulosConfig.opcion3 +
          modulosConfig.opcion4 +
          modulosConfig.opcion5 +
          modulosConfig.opcion6 +
          modulosConfig.opcion7,
        accopuser: usuarios,
        accopperson: personas,
        accopmoneda: moneda,
        accinventario: minventario,
        accventas: mventas,
        acccompras: mcompras,
        acccontabilidad: mcontabilidad,
        accfinanzas: mfinanzas,
        accbtnregalmacen: inv1,
        accbtnubialmacen: inv2,
        accbtnumedida: inv3,
        accbtnmarca: inv4,
        accbtnmodelo: inv5,
        accbtntproducto: inv6,
        accbtnproducto: inv7,
        accbtnopinventario: inv8,
        accbtnactxlsx: inv9,
        accbtntvacios: inv10,
        accbtnireports: inv11,
        accbtnclientes: vent1,
        accbtnvendedor: vent2,
        accbtnpedidos: vent3,
        accbtnnentrega: vent4,
        accbtnndebito: vent5,
        accbtnfacturas: vent6,
        accbtnpresupuesto: vent7,
        accbtnvreports: vent8,
        accbtnproveedores: compr1,
        accbtnordencompra: compr2,
        accbtnfactucompra: compr3,
        accbtncreports: compr4,
        accbtncntcontable: contb1,
        accbtnastcntable: contb2,
        accbtnmvbancariost: contb3,
        accbtnvinculacuenta: contb4,
        accbtncntreports: contb5,
        accbtnmvbancarios: finaz1,
        accbtnmvbancariost: finaz2,
        accbtnbancos: finaz3,
        accbtnbeneficiarios: finaz4,
        accbtnctsbancarias: finaz5,
        accbtncnciliabancaria: finaz6,
        accbtncntxcobrar: finaz7,
        accbtncntxpagar: finaz8,
        accbtntipretenciones: finaz9,
        accbtnfreports: finaz10,
        accopuserapp: usuariosapp,
        accvacios: vacios,
        btnopvacios: vacio1,
        btncontvacios: vacio2,
        btnclasvacios: vacio3,
        btnreportvacios: vacio4,
        accservicios: servicios,
        btnreportserv: servicio5,
        ordservicios: servicio1,
        accmoviles: servicio2,
        accgservicios: servicio3,
        accservnota: servicio4,
        accpostventas: postventas,
        postventa: postventa1,
        accinicio: permiinicio,
        supervisor: essupervisor === 1 ? true : false,
        passwsupervisor: postventa2 === true ? txtPasswordsuv.current.value : null,
        accbtnfacturaxnotas: vent9,
        tipoprecio: cmbTipoPrecioGlobal.current.value,
      });
      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });

      setUsuario(user);
      setPersona(datoPer);
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
    blanquear();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);
  const mostrarPasswordsup = () => setMostrarClavesup(!mostrarClavesup);

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);
        setTabIndex(0);
        setTabIndex1(0);

        if (props.operacion !== 1) {
          setOperacionPer(0);
          if (
            props.usuario.idagente !== null &&
            props.usuario.idagente !== ""
          ) {
            seleccionarVendedor(props.usuario.idagente, 1);
          }

          if (props.usuario.accaplicaciones !== "") {
            setAplica(props.usuario.accaplicaciones);
            let essuper = props.usuario && props.usuario.supervisor === true ? 1 : 0;
            setEssupervisor(essuper);
            if (
              props.usuario.accaplicaciones.toString().substring(0, 1) === "1"
            ) {
              if (props.usuario && props.usuario.accinventario !== "") {
                setModuloinventario({
                  inve1: props.usuario.accinventario.toString().substring(0, 1),
                  inve2: props.usuario.accinventario.toString().substring(1, 2),
                  inve3: props.usuario.accinventario.toString().substring(2, 3),
                  inve4: props.usuario.accinventario.toString().substring(3, 4),
                  inve5: props.usuario.accinventario.toString().substring(4, 5),
                  inve6: props.usuario.accinventario.toString().substring(5, 6),
                  inve7: props.usuario.accinventario.toString().substring(6, 7),
                  inve8: props.usuario.accinventario.toString().substring(7, 8),
                  inve9: props.usuario.accinventario.toString().substring(8, 9),
                  inve10: props.usuario.accinventario
                    .toString()
                    .substring(9, 10),
                  inve11: props.usuario.accinventario
                    .toString()
                    .substring(10, 11),
                  inve12: props.usuario.accinventario
                    .toString()
                    .substring(11, 12),
                });
              } else {
              }

              moduinventariosi.current.checked = true;
              moduinventariono.current.checked = false;
              setModu1(1);
            } else {
              moduinventariono.current.checked = true;
              moduinventariosi.current.checked = false;
              setModu1(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(1, 2) === "1"
            ) {
              if (props.usuario && props.usuario.accventas !== "") {
                setModuloventas({
                  vents1: props.usuario.accventas.toString().substring(0, 1),
                  vents2: props.usuario.accventas.toString().substring(1, 2),
                  vents3: props.usuario.accventas.toString().substring(2, 3),
                  vents4: props.usuario.accventas.toString().substring(3, 4),
                  vents5: props.usuario.accventas.toString().substring(4, 5),
                  vents6: props.usuario.accventas.toString().substring(5, 6),
                  vents7: props.usuario.accventas.toString().substring(6, 7),
                  vents8: props.usuario.accventas.toString().substring(7, 8),
                  vents9: props.usuario.accventas.toString().substring(8, 9),
                  vents10: props.usuario.accventas.toString().substring(9, 10),
                });
              }

              moduventassi.current.checked = true;
              moduventasno.current.checked = false;
              setModu2(1);
            } else {
              moduventasno.current.checked = true;
              moduventassi.current.checked = false;
              setModu2(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(2, 3) === "1"
            ) {
              if (props.usuario && props.usuario.acccompras !== "") {
                setModulocompras({
                  mcompras1: props.usuario.acccompras
                    .toString()
                    .substring(0, 1),
                  mcompras2: props.usuario.acccompras
                    .toString()
                    .substring(1, 2),
                  mcompras3: props.usuario.acccompras
                    .toString()
                    .substring(2, 3),
                  mcompras4: props.usuario.acccompras
                    .toString()
                    .substring(3, 4),
                  mcompras5: props.usuario.acccompras
                    .toString()
                    .substring(4, 5),
                });
              }

              moducomprassi.current.checked = true;
              moducomprasno.current.checked = false;
              setModu3(1);
            } else {
              moducomprasno.current.checked = true;
              moducomprassi.current.checked = false;
              setModu3(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(3, 4) === "1"
            ) {
              if (props.usuario && props.usuario.acccontabilidad !== "") {
                setModulocontabilidad({
                  mcontab1: props.usuario.acccontabilidad
                    .toString()
                    .substring(0, 1),
                  mcontab2: props.usuario.acccontabilidad
                    .toString()
                    .substring(1, 2),
                  mcontab3: props.usuario.acccontabilidad
                    .toString()
                    .substring(2, 3),
                  mcontab4: props.usuario.acccontabilidad
                    .toString()
                    .substring(3, 4),
                  mcontab5: props.usuario.acccontabilidad
                    .toString()
                    .substring(4, 5),
                  mcontab6: props.usuario.acccontabilidad
                    .toString()
                    .substring(5, 6),
                });
              }

              moducontabsi.current.checked = true;
              moducontabno.current.checked = false;
              setModu4(1);
            } else {
              moducontabno.current.checked = true;
              moducontabsi.current.checked = false;
              setModu4(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(4, 5) === "1"
            ) {
              if (props.usuario && props.usuario.accfinanzas !== "") {
                setModulofinanzas({
                  mfinanzas1: props.usuario.accfinanzas
                    .toString()
                    .substring(0, 1),
                  mfinanzas2: props.usuario.accfinanzas
                    .toString()
                    .substring(1, 2),
                  mfinanzas3: props.usuario.accfinanzas
                    .toString()
                    .substring(2, 3),
                  mfinanzas4: props.usuario.accfinanzas
                    .toString()
                    .substring(3, 4),
                  mfinanzas5: props.usuario.accfinanzas
                    .toString()
                    .substring(4, 5),
                  mfinanzas6: props.usuario.accfinanzas
                    .toString()
                    .substring(5, 6),
                  mfinanzas7: props.usuario.accfinanzas
                    .toString()
                    .substring(6, 7),
                  mfinanzas8: props.usuario.accfinanzas
                    .toString()
                    .substring(7, 8),
                  mfinanzas9: props.usuario.accfinanzas
                    .toString()
                    .substring(8, 9),
                  mfinanzas10: props.usuario.accfinanzas
                    .toString()
                    .substring(9, 10),
                  mfinanzas11: props.usuario.accfinanzas
                    .toString()
                    .substring(10, 11),
                  mfinanzas12: props.usuario.accfinanzas
                    .toString()
                    .substring(11, 12),
                });
              }

              modufinanzassi.current.checked = true;
              modufinanzasno.current.checked = false;
              setModu5(1);
            } else {
              modufinanzasno.current.checked = true;
              modufinanzassi.current.checked = false;
              setModu5(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(5, 6) === "1"
            ) {
              moduconfigsi.current.checked = true;
              moduconfigno.current.checked = false;
              setModu6(1);
            } else {
              moduconfigno.current.checked = true;
              moduconfigsi.current.checked = false;
              setModu6(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(6, 7) === "1"
            ) {
              if (props.usuario && props.usuario.accvacios !== "") {

                let data = [];
                data.push({
                  vacios1: props.usuario.accvacios
                    .toString()
                    .substring(0, 1),
                  vacios2: props.usuario.accvacios
                    .toString()
                    .substring(1, 2),
                  vacios3: props.usuario.accvacios
                    .toString()
                    .substring(2, 3),
                  vacios4: props.usuario.accvacios
                    .toString()
                    .substring(3, 4),
                  vacios5: props.usuario.accvacios
                    .toString()
                    .substring(4, 5),
                });

                setModulovacios({
                  vacios1: data[0].vacios1,
                  vacios2: data[0].vacios2,
                  vacios3: data[0].vacios3,
                  vacios4: data[0].vacios4,
                  vacios5: data[0].vacios5,
                });

              }

              moduvaciossi.current.checked = true;
              moduvaciosno.current.checked = false;
              setModu7(1);
            } else {
              moduvaciosno.current.checked = true;
              moduvaciossi.current.checked = false;
              setModu7(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(7, 8) === "1"
            ) {
              if (props.usuario && props.usuario.accservicios !== "") {

                let data = [];
                data.push({
                  servicios1: props.usuario.accservicios
                    .toString()
                    .substring(0, 1),
                  servicios2: props.usuario.accservicios
                    .toString()
                    .substring(1, 2),
                  servicios3: props.usuario.accservicios
                    .toString()
                    .substring(2, 3),
                  servicios4: props.usuario.accservicios
                    .toString()
                    .substring(3, 4),
                  servicios5: props.usuario.accservicios
                    .toString()
                    .substring(4, 5),
                  servicios6: props.usuario.accservicios
                    .toString()
                    .substring(5, 6),
                });

                setModuloservicios({
                  servicio1: data[0].servicios1,
                  servicio2: data[0].servicios2,
                  servicio3: data[0].servicios3,
                  servicio4: data[0].servicios4,
                  servicio5: data[0].servicios5,
                  servicio6: data[0].servicios6,
                });

              }

              moduserviciossi.current.checked = true;
              moduserviciosno.current.checked = false;
              setModu8(1);
            } else {
              moduserviciosno.current.checked = true;
              moduserviciossi.current.checked = false;
              setModu8(0);
            }

            if (
              props.usuario.accaplicaciones.toString().substring(8, 9) === "1"
            ) {

              if (props.usuario && props.usuario.accpostventas !== "") {

                let data = [];
                data.push({
                  postventa1: props.usuario.accpostventas
                    .toString()
                    .substring(0, 1),
                  postventa2: props.usuario.supervisor === true ? "1" : "0",
                  postventa3: props.usuario.accpostventas
                    .toString()
                    .substring(2, 3),
                  postventa4: props.usuario.accpostventas
                    .toString()
                    .substring(3, 4),
                  postventa5: props.usuario.accpostventas
                    .toString()
                    .substring(4, 5),
                  postventa6: props.usuario.accpostventas
                    .toString()
                    .substring(5, 6),
                });
                setModulopostventa({
                  postventa1: data[0].postventa1,
                  postventa2: data[0].postventa2,
                  postventa3: data[0].postventa3,
                  postventa4: data[0].postventa4,
                  postventa5: data[0].postventa5,
                  postventa6: data[0].postventa6,
                });

              }
              modupostventasi.current.checked = true;
              modupostventano.current.checked = false;
              setModu9(1);
            } else {
              modupostventano.current.checked = true;
              modupostventasi.current.checked = false;
              setModu9(0);
            }

            if (props.usuario && props.usuario.supervisor) {
              if (essuper !== 1) {
                chksupervisor.current.checked = false;
              } else {
                chksupervisor.current.checked = true;
              }
            }

          } else {
            moduinventariosi.current.checked = false;
            moduinventariono.current.checked = false;
            moduconfigno.current.checked = false;
            moduconfigsi.current.checked = false;
            modufinanzasno.current.checked = false;
            modufinanzassi.current.checked = false;
            moducontabno.current.checked = false;
            moducontabsi.current.checked = false;
            moducomprasno.current.checked = false;
            moducomprassi.current.checked = false;
            moduventasno.current.checked = false;
            moduventassi.current.checked = false;
            moduvaciosno.current.checked = false;
            moduvaciossi.current.checked = false;
            moduserviciosno.current.checked = false;
            moduserviciossi.current.checked = false;
            modupostventano.current.checked = false;
            modupostventasi.current.checked = false;
          }

          setModulosini({
            moduini: props.usuario.accinicio.toString().substring(0, 1),
          });

          setModulosConfig({
            opcion1: props.usuario.accconfiggene.toString().substring(0, 1),
            opcion2: props.usuario.accconfiggene.toString().substring(1, 2),
            opcion3: props.usuario.accconfiggene.toString().substring(2, 3),
            opcion4: props.usuario.accconfiggene.toString().substring(3, 4),
            opcion5: props.usuario.accconfiggene.toString().substring(4, 5),
            opcion6: props.usuario.accconfiggene.toString().substring(5, 6),
            opcion7: props.usuario.accconfiggene.toString().substring(6, 7)
          });

          setOperacionesMod({
            personas1: props.usuario.accopperson.toString().substring(0, 1),
            personas2: props.usuario.accopperson.toString().substring(1, 2),
            personas3: props.usuario.accopperson.toString().substring(2, 3),
            personas4: props.usuario.accopperson.toString().substring(3, 4),

            usuarios1: props.usuario.accopuser.toString().substring(0, 1),
            usuarios2: props.usuario.accopuser.toString().substring(1, 2),
            usuarios3: props.usuario.accopuser.toString().substring(2, 3),
            usuarios4: props.usuario.accopuser.toString().substring(3, 4),

            usuarioapp1: props.usuario.accopuserapp.toString().substring(0, 1),
            usuarioapp2: props.usuario.accopuserapp.toString().substring(1, 2),
            usuarioapp3: props.usuario.accopuserapp.toString().substring(2, 3),
            usuarioapp4: props.usuario.accopuserapp.toString().substring(3, 4),

            unidadcontable1: props.usuario.accopmoneda
              .toString()
              .substring(0, 1),
            unidadcontable2: props.usuario.accopmoneda
              .toString()
              .substring(1, 2),
            unidadcontable3: props.usuario.accopmoneda
              .toString()
              .substring(2, 3),
            unidadcontable4: props.usuario.accopmoneda
              .toString()
              .substring(3, 4),
          });
        } else {
          setModu1(0);
          setModu2(0);
          setModu3(0);
          setModu4(0);
          setModu5(0);
          setModu6(0);
          setModu7(0);
          setModu8(0);
          setModu9(0);
          setModu10(0);
          setModulosConfig({
            opcion1: "0",
            opcion2: "0",
            opcion3: "0",
            opcion4: "0",
            opcion5: "0",
            opcion6: "0",
            opcion7: "0"
          });
          setAplica("0000000000");
          setModuloinventario({
            inve1: "0",
            inve2: "0",
            inve3: "0",
            inve4: "0",
            inve5: "0",
            inve6: "0",
            inve7: "0",
            inve8: "0",
            inve9: "0",
            inve10: "0",
            inve11: "0",
            inve12: "0",
          });
          setModuloventas({
            vents1: "0",
            vents2: "0",
            vents3: "0",
            vents4: "0",
            vents5: "0",
            vents6: "0",
            vents7: "0",
            vents8: "0",
            vents9: "0",
            vents10: "0"
          });
          setModulocompras({
            mcompras1: "0",
            mcompras2: "0",
            mcompras3: "0",
            mcompras4: "0",
            mcompras5: "0",
          });
          setModulovacios({
            vacios1: "0",
            vacios2: "0",
            vacios3: "0",
            vacios4: "0",
            vacios5: "0",
          });
          setModuloservicios({
            servicio1: "0",
            servicio2: "0",
            servicio3: "0",
            servicio4: "0",
            servicio5: "0",
            servicio6: "0"
          });
          setModulopostventa({
            postventa1: "0",
            postventa2: "0",
            postventa3: "0",
            postventa4: "0",
            postventa5: "0",
            postventa6: "0"
          });
          setModulocontabilidad({
            mcontab1: "0",
            mcontab2: "0",
            mcontab3: "0",
            mcontab4: "0",
            mcontab5: "0",
            mcontab6: "0",
          });
          setModulofinanzas({
            mfinanzas1: "0",
            mfinanzas2: "0",
            mfinanzas3: "0",
            mfinanzas4: "0",
            mfinanzas5: "0",
            mfinanzas6: "0",
            mfinanzas7: "0",
            mfinanzas8: "0",
            mfinanzas9: "0",
            mfinanzas10: "0",
            mfinanzas11: "0",
            mfinanzas12: "0",
          });
          setModulosini({
            moduini: "0"
          });
          moduinventariosi.current.checked = false;
          moduinventariono.current.checked = true;
          moduconfigno.current.checked = true;
          moduconfigsi.current.checked = false;
          modufinanzasno.current.checked = true;
          modufinanzassi.current.checked = false;
          moducontabno.current.checked = true;
          moducontabsi.current.checked = false;
          moducomprasno.current.checked = true;
          moducomprassi.current.checked = false;
          moduventasno.current.checked = true;
          moduventassi.current.checked = false;
          moduvaciosno.current.checked = true;
          moduvaciossi.current.checked = false;
          modupostventasi.current.checked = false;
          modupostventano.current.checked = true;
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Usuario"
              : operacion === 2
                ? "Modificar Usurario"
                : operacion === 3
                  ? "Eliminar Usuario"
                  : "Consultar Usuario"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <CambiarClave
          usuario={props.usuario && props.usuario.login.trim()}
          show={mostrar2}
          onHide={() => {
            setMostrar2(false);
          }}
        />

        <CatalogoCliente
          show={catalogoCliente}
          nomid={"vendedor"}
          onHideCancelar={() => setCatalogoCliente(false)}
          onHideAceptaCatalogo={onCatalogoCliente}
        />

        <CatalogoPersona
          titulo={titulo}
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatPer={handleCloseCatalogoPer}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />

        <CatalogoOrganizacion
          show={mostrar}
          onHideCancelar={() => {
            setMostrar(false);
          }}
          onHideAceptaCatalogo={handleAceptaCatalogoOrg}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className="">
          <div>
            <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active "
                  style={{ backgroundColor: "#25d366" }}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#tab-1"
                  role="tab"
                  aria-controls="tab-1"
                  aria-selected="true"
                >
                  <i className="fas fa-user-edit fa-fw me-2"></i>Usuario
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="ex-with-icons-tab-2"
                  style={{ backgroundColor: "#55acee" }}
                  data-mdb-toggle="tab"
                  href="#tab-2"
                  role="tab"
                  aria-controls="tab-2"
                  aria-selected="false"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos
                  Aplicaciones
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="ex-with-icons-tab-3"
                  style={{ backgroundColor: "rgb(238, 85, 85)" }}
                  data-mdb-toggle="tab"
                  href="#tab-3"
                  role="tab"
                  aria-controls="tab-3"
                  aria-selected="false"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos Config.
                  General
                </a>
              </li>
            </ul>
            <div className="tab-content" id="ex-with-icons-content">
              <div
                className="tab-pane fade show active"
                id="tab-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="container-fluid row m-0 h-100 py-2 px-4  mx-auto">
                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtIdUsuario}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.usuario ? props.usuario.idusuario : ""
                      }
                      id="inputCodigo"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-8">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>Nom.
                      Usuario:
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtLogin}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={props.usuario ? props.usuario.login : ""}
                      id="inputLogin"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {" "}
                      Estatus
                    </label>
                    <select
                      disabled={deshabilitado}
                      ref={cmbStatus}
                      className="form-select"
                      aria-label="Default select example"
                      defaultValue={props.usuario ? props.usuario.status : ""}
                    >
                      <option value="1">Activo</option>
                      <option value="2">Inactivo</option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>
                      Contraseña:
                    </label>
                    <input
                      type={mostrarClave ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>Confir.
                      Contr.:
                    </label>
                    <input
                      type={mostrarClave1 ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtConfirmPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputConfirmPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword1}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="col-md-12 py-1"></div>
                  {props.menu === "sistema" && (
                    <fieldset className="row border-azul rounded mx-auto">
                      <legend className="float-none m-0 w-auto">
                        Organización
                      </legend>

                      <div className="input-group py-1 input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-id-card"></i>Código:
                        </label>
                        <input
                          type="text"
                          disabled={deshabilitado}
                          ref={txtIdAgente}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputIdAgente"
                          defaultValue={
                            props.usuario ? props.usuario.idorganizacion : ""
                          }
                          onKeyUp={validarAgente}
                          onBlur={validarAgente}
                        />
                        <button
                          disabled={deshabilitado}
                          onClick={() => {
                            setMostrar(true);
                          }}
                          className="btn btn-sm  btn-success"
                        >
                          <i
                            disabled={deshabilitado}
                            className="fa fa-search"
                          ></i>{" "}
                        </button>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-8">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Nombres:
                        </label>
                        <input
                          type="text"
                          disabled={true}
                          ref={txtNombreAgente}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputNomUsuario"
                          defaultValue={
                            props.usuario ? props.usuario.nombreorg.trim() : ""
                          }
                        />
                      </div>
                    </fieldset>
                  )}

                  {props.menu !== "sistema" && (
                    <fieldset className="row border-azul rounded mx-auto">
                      <legend className="float-none m-0 w-auto">
                        Vendedor
                      </legend>

                      <input
                        ref={txtIdVendedor}
                        type="hidden"
                        name="idvendedor"
                      />

                      <div className="mb-1 col-pd-260 px-2">
                        <div className="input-group input-group-sm">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            Cedula/Rif
                          </label>
                          <select
                            ref={cmbRif}
                            name="cmbrif"
                            disabled={deshabilitado}
                            className="form-select form-select-sm text-center col-3"
                            aria-label=".form-select-sm example"
                            onChange={onChange}
                          >
                            <option value="">--</option>
                            {cmbCedula &&
                              cmbCedula.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {" "}
                                  {item.value}{" "}
                                </option>
                              ))}
                          </select>
                          <input
                            ref={txtRif}
                            autoComplete="off"
                            disabled={deshabilitado}
                            maxLength={9}
                            type="text"
                            className="form-control"
                            name="cedula"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={validarCliente}
                            onBlur={validarCliente}
                            onChange={onChange}
                          />
                          <button
                            type="button"
                            disabled={deshabilitado}
                            onClick={() => {
                              setCatalogoCliente(true);
                            }}
                            className="btn btn-success"
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>
                      </div>
                      <div className="input-group pb-1 input-group-sm col-pd-130">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          Caja:
                        </label>
                        <select
                          disabled={deshabilitado}
                          ref={cmbCaja}
                          className="form-select"
                          aria-label="numero de caja"
                          defaultValue={
                            props.usuario ? props.usuario.numcaja : ""
                          }
                        >
                          <option value="">--</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                        </select>
                      </div>
                      <div className="input-group input-group-sm mb-2 col-md-12">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          Nombre/Razón Social
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          ref={txtRazon}
                          disabled
                          name="nombres"
                          className="form-control text-uppercase"
                          onChange={onChange}
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                    </fieldset>
                  )}
                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">
                      Datos Personales del Usuario
                    </legend>

                    <div className="container col-md-12 row m-0 justify-content-between">
                      <div className="input-group py-1 input-group-sm px-1 col-pd-170">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-id-card"></i>Cedula:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          maxLength={8}
                          disabled={deshabilitado}
                          ref={txtCedula}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCedula"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.cedula
                              : ""
                          }
                          onKeyUp={validarPersona}
                          onBlur={validarPersona}
                        />
                        {/*                  <button disabled={deshabilitado} onClick={catalogoPer} className="btn btn-sm  btn-success" ><i disabled={deshabilitado} className="fa fa-search"></i> </button> */}
                      </div>
                      <div
                        style={{ width: 210 }}
                        className="input-group py-1 input-group-sm px-2"
                      >
                        <label
                          style={{ width: 110 }}
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-map-marked-alt"></i>
                          Nacionalidad:
                        </label>
                        <select
                          style={{ minWidth: 70, maxWidth: 70 }}
                          disabled={!habilitadoNU}
                          ref={cmbNacionalidad}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nacionalidad
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example col-md-"
                        >
                          <option key="0" value="V">
                            V
                          </option>
                          <option key="1" value="E">
                            E
                          </option>
                        </select>
                      </div>
                      <div
                        style={{ width: 160 }}
                        className="input-group py-1 input-group-sm px-1"
                      >
                        <label
                          style={{ width: 80 }}
                          className="input-group-text ml-2"
                          id="inputGroup-sizing-sm"
                        >
                          Sexo:
                        </label>
                        <select
                          style={{ width: 50 }}
                          disabled={!habilitadoNU}
                          ref={cmbSexo}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.sexo
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option key="0" value="M">
                            M
                          </option>
                          <option key="1" value="F">
                            F
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0 justify-content-between">
                      <div className="input-group py-1 input-group-sm px-1 col-sm-6">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Nombres:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={!habilitadoNU}
                          ref={txtNombreUsuario}
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputNomUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nombres.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm px-1 col-sm-6">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          apellidos:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={!habilitadoNU}
                          ref={txtApellidoUsuario}
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.apellidos.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Direccion:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={!habilitadoNU}
                          ref={txtDireccionUsuario}
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.direccion.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm px-1 col-pd-250">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-calendar-alt"></i>
                          Fecha Nacimiento:
                        </label>
                        <input
                          type="date"
                          disabled={!habilitadoNU}
                          ref={txtFechaNac}
                          className="form-control px-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputFechaNac"
                          max={moment(fechaSistema).format("YYYY-MM-DD")}
                          defaultValue={
                            props.datospersonales
                              ? moment(
                                props.datospersonales.fnacimiento
                              ).format("YYYY-MM-DD")
                              : ""
                          }
                          onKeyUp={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-pd-210">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-phone"></i>Telefono:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={!habilitadoNU}
                          ref={txtTlfUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputTlfUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf1 !== null
                                ? props.datospersonales.tlf1.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>

                      <div
                        style={{ width: 180 }}
                        className="input-group py-1 input-group-sm px-1"
                      >
                        <label
                          style={{ width: 70 }}
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-mobile-alt"></i>
                          Celular:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          style={{ width: 80 }}
                          disabled={!habilitadoNU}
                          ref={txtCelUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCelUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf2 !== null
                                ? props.datospersonales.tlf2.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-pd-410 px-1 ml-auto">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          {" "}
                          <i className="fas fa-lg px-1 fa-at"></i>E-mail:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={!habilitadoNU}
                          ref={txtEmailUsuario}
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputEmailUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.correoe !== null
                                ? props.datospersonales.correoe.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="tab-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Inventario</div>
                      <div className="form-check col px-3 form-check-inline px-2 mb-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodtimbre"
                          disabled={deshabilitado}
                          id="inlineRadio1"
                          value={true}
                          ref={moduinventariosi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2 mb-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodtimbre"
                          disabled={deshabilitado}
                          id="inlineRadio2"
                          value={false}
                          ref={moduinventariono}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>

                      {modu1 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkitodos}
                                    defaultChecked={
                                      moduloinventario.inve1 === "1" &&
                                        moduloinventario.inve2 === "1" &&
                                        moduloinventario.inve3 === "1" &&
                                        moduloinventario.inve4 === "1" &&
                                        moduloinventario.inve5 === "1" &&
                                        moduloinventario.inve6 === "1" &&
                                        moduloinventario.inve7 === "1" &&
                                        moduloinventario.inve8 === "1" &&
                                        moduloinventario.inve9 === "1" &&
                                        moduloinventario.inve10 === "1" &&
                                        moduloinventario.inve11 === "1" &&
                                        moduloinventario.inve12 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkTodo}
                                    name="todosinventario"
                                    id="inlineCheckbox"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkralmacen}
                                    defaultChecked={
                                      moduloinventario.inve1 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox1"
                                  >
                                    Reg. Almacen
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkubialmacen}
                                    defaultChecked={
                                      moduloinventario.inve2 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox2"
                                  >
                                    Ubi. Almacen
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkudmedida}
                                    defaultChecked={
                                      moduloinventario.inve3 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox3"
                                  >
                                    Unda. Medida
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkmarca}
                                    defaultChecked={
                                      moduloinventario.inve4 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox4"
                                  >
                                    Marca
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkmodelo}
                                    defaultChecked={
                                      moduloinventario.inve5 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox5"
                                  >
                                    Modelo
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chktpproduct}
                                    defaultChecked={
                                      moduloinventario.inve6 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox6"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox6"
                                  >
                                    Tipo. Producto
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkproducto}
                                    defaultChecked={
                                      moduloinventario.inve7 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox7"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox7"
                                  >
                                    Productos
                                  </label>
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkopinventario}
                                    defaultChecked={
                                      moduloinventario.inve8 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox8"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox8"
                                  >
                                    Op. Inventario
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkactxlsx}
                                    defaultChecked={
                                      moduloinventario.inve9 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox9"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox9"
                                  >
                                    Actu. XLSX
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkgvacios}
                                    defaultChecked={
                                      moduloinventario.inve10 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox10"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox10"
                                  >
                                    Gest. Vacios
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkiconfigura}
                                    defaultChecked={
                                      moduloinventario.inve11 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox11"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox11"
                                  >
                                    Configuración
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={chkireports}
                                    defaultChecked={
                                      moduloinventario.inve12 === "1"
                                        ? true
                                        : false
                                    }
                                    onChange={checkBlank}
                                    id="inlineCheckbox12"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox12"
                                  >
                                    Reportes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Ventas</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodminas"
                          disabled={deshabilitado}
                          id="inlineRadiov1"
                          value={true}
                          ref={moduventassi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiov1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodminas"
                          disabled={deshabilitado}
                          id="inlineRadiov2"
                          value={false}
                          ref={moduventasno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiov2">
                          No Disponible
                        </label>
                      </div>

                      {modu2 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvtodos}
                                    disabled={deshabilitado}
                                    onChange={checkTodo}
                                    defaultChecked={
                                      moduloventas.vents1 === "1" &&
                                        moduloventas.vents2 === "1" &&
                                        moduloventas.vents3 === "1" &&
                                        moduloventas.vents4 === "1" &&
                                        moduloventas.vents5 === "1" &&
                                        moduloventas.vents6 === "1" &&
                                        moduloventas.vents7 === "1" &&
                                        moduloventas.vents8 === "1" &&
                                        moduloventas.vents9 === "1" &&
                                        moduloventas.vents10 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todosventas"
                                    type="checkbox"
                                    id="checkVentas"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkclientes}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents1 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas1"
                                  >
                                    Clientes
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvendedores}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents2 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas2"
                                  >
                                    Vendedores
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkpedidos}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents3 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas3"
                                  >
                                    Pedidos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chknentrega}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents4 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas4"
                                  >
                                    Notas/Entrega
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkndebito}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents5 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas5"
                                  >
                                    Notas/Debito
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkfactura}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents6 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas6"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas6"
                                  >
                                    Facturas
                                  </label>
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkfacturaxnotas}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents10 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas10"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas10"
                                  >
                                    Facturas por Notas de Entrega
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkpresupuesto}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents7 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas7"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas7"
                                  >
                                    Presupuestos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvconfi}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents8 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas8"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas8"
                                  >
                                    Configuración
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvreports}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloventas.vents9 === "1" ? true : false
                                    }
                                    onChange={checkBlank}
                                    type="checkbox"
                                    id="checkVentas9"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas9"
                                  >
                                    Reportes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Compras</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permod1x500"
                          disabled={deshabilitado}
                          id="inlineRadioc1"
                          value={true}
                          ref={moducomprassi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioc1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permod1x500"
                          disabled={deshabilitado}
                          id="inlineRadioc2"
                          value={false}
                          ref={moducomprasno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioc2">
                          No Disponible
                        </label>
                      </div>

                      {modu3 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcptodos}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={
                                      modulocompras.mcompras1 === "1" &&
                                        modulocompras.mcompras2 === "1" &&
                                        modulocompras.mcompras3 === "1" &&
                                        modulocompras.mcompras4 === "1" &&
                                        modulocompras.mcompras5 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todoscompras"
                                    id="checkCompras"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkproveedores}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocompras.mcompras1 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkCompras1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras1"
                                  >
                                    Proveedores
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkordencompra}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocompras.mcompras2 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkCompras2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras2"
                                  >
                                    Ordenes/Compras
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkfactucompra}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocompras.mcompras3 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkCompras3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras3"
                                  >
                                    Facturas/Compras
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcpconfig}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocompras.mcompras4 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkCompras4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras4"
                                  >
                                    Configuración
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcpreports}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocompras.mcompras5 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkCompras5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras5"
                                  >
                                    Reportes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Modulo Contabilidad</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodprod"
                          disabled={deshabilitado}
                          id="inlineRadiocb1"
                          value={true}
                          ref={moducontabsi}
                          onChange={handleChangeOtro}
                        />
                        <label
                          className="form-check-label"
                          for="inlineRadiocb1"
                        >
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodprod"
                          disabled={deshabilitado}
                          id="inlineRadiocb2"
                          value={false}
                          ref={moducontabno}
                          onChange={handleChangeOtro}
                        />
                        <label
                          className="form-check-label"
                          for="inlineRadiocb2"
                        >
                          No Disponible
                        </label>
                      </div>

                      {modu4 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcnttodos}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={
                                      modulocontabilidad.mcontab1 === "1" &&
                                        modulocontabilidad.mcontab2 === "1" &&
                                        modulocontabilidad.mcontab3 === "1" &&
                                        modulocontabilidad.mcontab4 === "1" &&
                                        modulocontabilidad.mcontab5 === "1" &&
                                        modulocontabilidad.mcontab6 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todoscontabilidad"
                                    id="checkContabilidad"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcatctcontable}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocontabilidad.mcontab1 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkContabilidad1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad1"
                                  >
                                    Cat. Cuentas Contable
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkasientcntable}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocontabilidad.mcontab2 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkContabilidad2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad2"
                                  >
                                    Asientos Contables
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvincuenta}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocontabilidad.mcontab3 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkContabilidad3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad3"
                                  >
                                    Vinculación/Cuentas
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkmovibancot}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocontabilidad.mcontab4 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkContabilidad4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad4"
                                  >
                                    Movimientos Bancarios
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcntconfig}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocontabilidad.mcontab5 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkContabilidad5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad5"
                                  >
                                    Configuración
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcntreports}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulocontabilidad.mcontab6 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkContabilidad6"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad6"
                                  >
                                    Reportes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Modulo Finanzas</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodfiscal"
                          disabled={deshabilitado}
                          id="inlineRadiof1"
                          value={true}
                          ref={modufinanzassi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiof1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodfiscal"
                          disabled={deshabilitado}
                          id="inlineRadiof2"
                          value={false}
                          ref={modufinanzasno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiof2">
                          No Disponible
                        </label>
                      </div>

                      {modu5 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkftodos}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas1 === "1" &&
                                        modulofinanzas.mfinanzas2 === "1" &&
                                        modulofinanzas.mfinanzas3 === "1" &&
                                        modulofinanzas.mfinanzas4 === "1" &&
                                        modulofinanzas.mfinanzas5 === "1" &&
                                        modulofinanzas.mfinanzas6 === "1" &&
                                        modulofinanzas.mfinanzas7 === "1" &&
                                        modulofinanzas.mfinanzas8 === "1" &&
                                        modulofinanzas.mfinanzas9 === "1" &&
                                        modulofinanzas.mfinanzas10 === "1" &&
                                        modulofinanzas.mfinanzas11 === "1" &&
                                        modulofinanzas.mfinanzas12 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todosfinanzas"
                                    id="inlineFinanzas"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkbancos}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas1 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas1"
                                  >
                                    Bancos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkbeneficiarios}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas2 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas2"
                                  >
                                    Beneficiarios
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkctasbancarias}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas3 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas3"
                                  >
                                    Cuentas Bancarias
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkmovibancarios}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas4 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas4"
                                  >
                                    Movimientos Bancarios
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkmovitransito}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas5 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas5"
                                  >
                                    Movimientos/Transito
                                  </label>
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkconciliacionbanco}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas6 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas6"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas6"
                                  >
                                    Conciliación Bancaria
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkctasxcobrar}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas7 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas7"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas7"
                                  >
                                    Cuentas x Cobrar
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkReverPagoAnti}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas12 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas12"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas12"
                                  >
                                    Reverzar Pago / Anticipo
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkctasxpagar}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas8 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas8"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas8"
                                  >
                                    Cuentas x Pagar
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chktiporetenciones}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas9 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas9"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas9"
                                  >
                                    Tipo/Retenciones
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkfconfig}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas10 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas10"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas10"
                                  >
                                    Configuración
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkfreports}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulofinanzas.mfinanzas11 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="inlineFinanzas11"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas11"
                                  >
                                    Reportes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Gestión de Vacios</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="vacios"
                          disabled={deshabilitado}
                          id="inlineRadiovacio1"
                          value={true}
                          ref={moduvaciossi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiovacio1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="vacios"
                          disabled={deshabilitado}
                          id="inlineRadiovacio2"
                          value={false}
                          ref={moduvaciosno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiovacio2">
                          No Disponible
                        </label>
                      </div>

                      {modu7 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvaciostodos}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={
                                      modulovacios.vacios1 === "1" &&
                                        modulovacios.vacios2 === "1" &&
                                        modulovacios.vacios3 === "1" &&
                                        modulovacios.vacios4 === "1" &&
                                        modulovacios.vacios5 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todosvacios"
                                    id="checkVacios"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVacios"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkopvacios}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulovacios.vacios1 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkVacios1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVacios1"
                                  >
                                    Operaciones de Inventario (Vacios)
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkcontrolvacios}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulovacios.vacios2 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkVacios2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVacios2"
                                  >
                                    Control de Vacios
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkclassvacios}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulovacios.vacios3 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkVacios3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVacios3"
                                  >
                                    Clasificador de Vacios
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvaciosconfig}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulovacios.vacios4 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkVacios4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVacios4"
                                  >
                                    Configuración
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkvaciosreports}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulovacios.vacios5 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkVacios5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVacios5"
                                  >
                                    Reportes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Servicios</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="servicios"
                          disabled={deshabilitado}
                          id="inlineRadioservicio1"
                          value={true}
                          ref={moduserviciossi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioservicio1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="servicios"
                          disabled={deshabilitado}
                          id="inlineRadioservicio2"
                          value={false}
                          ref={moduserviciosno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioservicio2">
                          No Disponible
                        </label>
                      </div>

                      {modu8 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkservtodos}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={
                                      moduloservicios.servicio1 === "1" &&
                                        moduloservicios.servicio2 === "1" &&
                                        moduloservicios.servicio3 === "1" &&
                                        moduloservicios.servicio4 === "1" &&
                                        moduloservicios.servicio5 === "1" &&
                                        moduloservicios.servicio6 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todosservicios"
                                    id="checkServicios"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkServicios"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkordenservi}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloservicios.servicio1 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkServicios1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkServicios1"
                                  >
                                    Gestión (Ordenes de Servicio)
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkmovilesservi}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloservicios.servicio2 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkServicios2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkServicios2"
                                  >
                                    Gestión de Moviles
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkgservicios}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloservicios.servicio3 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkServicios3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkServicios3"
                                  >
                                    Gestión de Servicios
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkservnotaent}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloservicios.servicio4 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkServicios4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkServicios4"
                                  >
                                    Nota de Entrega
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkservconfig}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloservicios.servicio5 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkServicios5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkServicios5"
                                  >
                                    Configuración
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkservreports}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      moduloservicios.servicio6 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkServicios6"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkServicios6"
                                  >
                                    Reportes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  {idorganizacion === '1' ? <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Post-Venta</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="ptventa"
                          disabled={deshabilitado}
                          id="inlineRadiopostventa1"
                          value={true}
                          ref={modupostventasi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiopostventa1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="ptventa"
                          disabled={deshabilitado}
                          id="inlineRadiopostventa2"
                          value={false}
                          ref={modupostventano}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiopostventa2">
                          No Disponible
                        </label>
                      </div>

                      {modu9 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkpostventtodos}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={
                                      modulopostventa.postventa1 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todospostventa"
                                    id="checkPostventa"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkPostventa"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={chkpostventventa}
                                    disabled={deshabilitado}
                                    defaultChecked={
                                      modulopostventa.postventa1 === "1"
                                        ? true
                                        : false
                                    }
                                    type="checkbox"
                                    onChange={checkBlank}
                                    id="checkPostventa1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkPostventa1"
                                  >
                                    Ventas
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline mx-auto">
                                  <div className="col-pd-250 px-0 m-0">
                                    <div className="input-group input-group-sm">
                                      <label className="input-group-text fw-bold text-black">
                                        TIPO DE PRECIO:
                                      </label>
                                      <select
                                        ref={cmbTipoPrecioGlobal}
                                        className="form-control form-control-sm"
                                        defaultValue={props.usuario && props.usuario.tipoprecio}
                                        disabled={deshabilitado}
                                      >
                                        <option value="1">PRECIO MAXIMO</option>
                                        <option value="2">PRECIO OFERTA</option>
                                        <option value="3">PRECIO MAYOR</option>
                                        <option value="4">PRECIO MINIMO</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        <div><input type="hidden" ref={cmbTipoPrecioGlobal} value={"1"} /></div>
                      )}
                      <div />
                    </div>
                  </div> : <div>
                    <input type="hidden" ref={modupostventasi} />
                    <input type="hidden" ref={modupostventano} />
                    <input type="hidden" ref={cmbTipoPrecioGlobal} value={"1"} />
                  </div>}

                  {essupervisor === 1 || idorganizacion === '1' ?
                    <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                      <table className="col-12 table table-sm table-bordered m-0 px-0">
                        <thead className="col-12 m-0 px-0">
                          <tr>
                            <th scope="col">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  ref={chksupervisor}
                                  disabled={essupervisor === 1 || idorganizacion === '1' ? false : true}
                                  defaultChecked={
                                    essupervisor === 1
                                      ? true
                                      : false
                                  }
                                  type="checkbox"
                                  onChange={checkBlank}
                                  id="checkSupervisor"
                                />
                                <label
                                  className="form-check-label"
                                  for="checkSupervisor"
                                >
                                  Supervisor
                                </label>
                              </div>
                            </th>
                            <th scope="col">
                              <div className="form-check form-check-inline">
                                <div className="input-group input-group-sm">
                                  <label
                                    className="input-group-text"
                                    id="inputGroup-sizing-sm"
                                  >
                                    <i className="fas fa-lg px-1 fa-unlock-alt"></i>
                                    Clave:
                                  </label>
                                  <input
                                    type={mostrarClavesup ? "text" : "password"}
                                    disabled={essupervisor === 1 ? false : true}
                                    ref={txtPasswordsuv}
                                    className="form-control"
                                    aria-label="Sizing example input"
                                    aria-describedby="inputGroup-sizing-sm"
                                    id="inputPasswordsup"
                                    defaultValue={essupervisor === 1 ? props.usuario && props.usuario.passwsupervisor : ''}
                                    onKeyUp={handleInputChange}
                                  />
                                  <button
                                    style={{ textAlign: "center", color: "white" }}
                                    disabled={essupervisor === 1 ? false : true}
                                    onClick={mostrarPasswordsup}
                                    className="btn btn-sm btn-info"
                                  >
                                    <i
                                      disabled={deshabilitado}
                                      className="fa fa-eye-slash"
                                    ></i>{" "}
                                  </button>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </table> </div>
                    : ''}

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Modulo Configuración</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodingresos"
                          disabled={deshabilitado}
                          id="inlineRadiocg1"
                          value={true}
                          ref={moduconfigsi}
                          onChange={handleChangeOtro}
                        />
                        <label
                          className="form-check-label"
                          for="inlineRadiocg1"
                        >
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permodingresos"
                          disabled={deshabilitado}
                          id="inlineRadiocg2"
                          value={false}
                          ref={moduconfigno}
                          onChange={handleChangeOtro}
                        />
                        <label
                          className="form-check-label"
                          for="inlineRadiocg2"
                        >
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="tab-3"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-3"
              >
                <div className="row mx-auto">
                  {/* Organización */}
                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Organización
                      </legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion1"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion1 === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion1"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion1 === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Ajustes
                      </legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion7"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion7 === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion7"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion7 === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Respaldo-BD
                      </legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion5"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion5 === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion5"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion5 === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Vista-Inicio
                      </legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="inicio"
                            value={"1"}
                            id="moduloini"
                            onChange={onChangeMonuini}
                            checked={
                              modulosini.moduini === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="inicio"
                            value={"0"}
                            id="moduloini"
                            onChange={onChangeMonuini}
                            checked={
                              modulosini.moduini === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* Personas */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Personas
                      </legend>
                      <div className="col-md-2 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion2"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion2 === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion2"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion2 === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                      {modulosConfig.opcion2 === "1" ? (
                        <div className="col-md-8 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkPerCon}
                                defaultChecked={
                                  operacionesMod.personas1 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Consultar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkPerIn}
                                defaultChecked={
                                  operacionesMod.personas2 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Incluir
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkPerMod}
                                defaultChecked={
                                  operacionesMod.personas3 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Modificar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkPerEli}
                                defaultChecked={
                                  operacionesMod.personas4 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Eliminar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                name="todopersonas"
                                ref={chkPerTodo}
                                defaultChecked={
                                  operacionesMod.personas1 === "1" &&
                                    operacionesMod.personas2 === "1" &&
                                    operacionesMod.personas3 === "1" &&
                                    operacionesMod.personas4 === "1"
                                    ? true
                                    : false
                                }
                                onChange={checkTodo}
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Todo
                              </label>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </fieldset>
                  </div>

                  {/* Usuarios */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Usuarios
                      </legend>
                      <div className="col-md-2 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion3"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion3 === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion3"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion3 === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                      {modulosConfig.opcion3 === "1" ? (
                        <div className="col-md-8 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuCon}
                                defaultChecked={
                                  operacionesMod.usuarios1 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Consultar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuIn}
                                defaultChecked={
                                  operacionesMod.usuarios2 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Incluir
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuMod}
                                defaultChecked={
                                  operacionesMod.usuarios3 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Modificar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuEli}
                                defaultChecked={
                                  operacionesMod.usuarios4 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Eliminar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                name="todousuarios"
                                id="flexCheckDefault"
                                ref={chkUsuTodo}
                                defaultChecked={
                                  operacionesMod.usuarios1 === "1" &&
                                    operacionesMod.usuarios2 === "1" &&
                                    operacionesMod.usuarios3 === "1" &&
                                    operacionesMod.usuarios4 === "1"
                                    ? true
                                    : false
                                }
                                onChange={checkTodo}
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Todo
                              </label>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </fieldset>
                  </div>

                  {/* Usuarios APP */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Usuarios-APP
                      </legend>
                      <div className="col-md-2 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion6"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion6 === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion6"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion6 === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                      {modulosConfig.opcion6 === "1" ? (
                        <div className="col-md-8 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuappCon}
                                defaultChecked={
                                  operacionesMod.usuarioapp1 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Consultar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuappIn}
                                defaultChecked={
                                  operacionesMod.usuarioapp2 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Incluir
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuappMod}
                                defaultChecked={
                                  operacionesMod.usuarioapp3 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Modificar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkUsuappEli}
                                defaultChecked={
                                  operacionesMod.usuarioapp4 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Eliminar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                name="todousuariosapp"
                                id="flexCheckDefault"
                                ref={chkUsuappTodo}
                                defaultChecked={
                                  operacionesMod.usuarioapp1 === "1" &&
                                    operacionesMod.usuarioapp2 === "1" &&
                                    operacionesMod.usuarioapp3 === "1" &&
                                    operacionesMod.usuarioapp4 === "1"
                                    ? true
                                    : false
                                }
                                onChange={checkTodo}
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Todo
                              </label>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </fieldset>
                  </div>

                  {/* Moneda */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend
                        className="float-none fw-bold w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Monedas
                      </legend>
                      <div className="col-md-2 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion4"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion4 === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="opcion4"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              modulosConfig.opcion4 === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                      {modulosConfig.opcion4 === "1" ? (
                        <div className="col-md-8 row mb-3 rounded">
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkMoneCon}
                                defaultChecked={
                                  operacionesMod.unidadcontable1 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Consultar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkMoneIn}
                                defaultChecked={
                                  operacionesMod.unidadcontable2 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Incluir
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkMoneMod}
                                defaultChecked={
                                  operacionesMod.unidadcontable3 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Modificar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                id="flexCheckDefault"
                                onChange={checkBlank}
                                ref={chkMoneEli}
                                defaultChecked={
                                  operacionesMod.unidadcontable4 === "1"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Eliminar
                              </label>
                            </div>
                          </div>
                          <div className="col d-flex justify-content-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                type="checkbox"
                                value="1"
                                name="todomonedas"
                                id="flexCheckDefault"
                                ref={chkMoneTodo}
                                defaultChecked={
                                  operacionesMod.unidadcontable1 === "1" &&
                                    operacionesMod.unidadcontable2 === "1" &&
                                    operacionesMod.unidadcontable3 === "1" &&
                                    operacionesMod.unidadcontable4 === "1"
                                    ? true
                                    : false
                                }
                                onChange={checkTodo}
                              />
                              <label
                                className="form-check-label py-1"
                                for="flexCheckDefault"
                              >
                                Todo
                              </label>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            onClick={() => {
              setMostrar2(true);
            }}
            style={{ visibility: operacion === 2 ? "visible" : "collapse" }}
            className="btn col-sm-3 mx-1 btn-warning btn-sm rounded-pill"
          >
            <i className="fas fa-key"> Cambiar Clave</i>{" "}
          </button>
          <button
            type="button"
            ref={btnAcepta}
            disabled={operacion === 4 ? true : false}
            onClick={onChangeValidar}
            className="col-sm-3 mx-1 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            className="col-sm-3 mx-1 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalActualizarUsuario;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalActualizarUsuario.js